import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import router from "../router";

const headers = { Accept: "application/json" };

Vue.use(Vuex);

function recalculateProduct(current_product, state, flash = false) {
  current_product.currency_factor = state.currency_factor;
  let n = 1;
  state.cart.forEach((o) => {
    n += parseInt(o.order_quantity);
  });
  let eligable = state.cart.length + 1 > 1 ? true : n > 1;
  if (flash) {
    eligable = false;
  }
  // console.log(
  //   "state.cart",
  //   state.cart.map((x) => x.flash_item),
  //   eligable
  // );
  const discount = state.country.multi_discount;

  if (state.cart.length == 0) {
    current_product.first = true;
  }

  current_product.base_cost = parseFloat(
    parseFloat(current_product.order_quantity) * current_product.price -
      parseFloat(current_product.order_quantity) * current_product.profit
  );

  const discount_amount = eligable
    ? discount *
      (parseFloat(current_product.order_quantity) -
        (current_product.first == true ? 1 : 0)) *
      current_product.currency_factor
    : 0;
  /// false, 1, 2, 0

  current_product.total = parseFloat(
    (
      current_product.base_cost -
      discount_amount +
      parseFloat(current_product.order_quantity) * current_product.user_profit
    ).toFixed(8)
  );

  current_product.base_total = parseFloat(
    (
      (current_product.base_cost -
        discount_amount +
        parseFloat(current_product.order_quantity) *
          current_product.user_profit) /
      current_product.currency_factor
    ).toFixed(8)
  );

  current_product.user_base_profit =
    current_product.user_profit / current_product.currency_factor;

  current_product.base_profit = current_product.user_base_profit;

  current_product.total_profit = (
    parseFloat(current_product.order_quantity) * current_product.user_profit
  ).toFixed(8);

  current_product.base_total_profit = (
    parseFloat(current_product.order_quantity) *
    current_product.user_base_profit
  ).toFixed(8);

  return current_product;
}

export default new Vuex.Store({
  state: {
    site: {
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/cip-generic.appspot.com/o/default-user.png?alt=media&token=82389d15-0419-4d2c-8b5e-5fe3e18c3ca7",
      language: "ar",
      logo: "/ninja-sellers-original.png",
      wlogo: "/ninja-sellers-inverted.png",
      name: "Ninja Sellers",
      theme: {
        light: {
          accent: "#BE202E",
          error: "#FF5252",
          info: "#2196F3",
          primary: "#BE202E",
          secondary: "#020203",
          success: "#4CAF50",
          warning: "#FFC107",
        },
      },
    },
    call_status_info: [
        {
          slug: "DESTINATION_OUT_OF_ORDER",
          ar: " لا يرد - غير متاح",
          en: "Does not respond - Not available"
        },
        {
          slug: "INCOMPATIBLE_DESTINATION",
          ar: " لا يرد - غير متاح",
          en: "Does not respond - Not available"
        },
        {
          slug: "INVALID_NUMBER_FORMAT",
          ar: "رقم خطاء",
          en: "Wrong number"
        },
        {
          slug: "NETWORK_OUT_OF_ORDER",
          ar: "لا يرد",
          en: "Does not respond"
        },
        {
          slug: "NORMAL_TEMPORARY_FAILURE",
          ar: "لا يرد",
          en: "Does not respond"
        },
        {
          slug: "NO_ANSWER",
          ar: "لا يرد",
          en: "Does not respond"
        },
        {
          slug: "NO_ROUTE_DESTINATION",
          ar: "لا يرد",
          en: "Does not respond"
        },
        {
          slug: "NO_USER_RESPONSE",
          ar: "لا يرد",
          en: "Does not respond"
        },
        {
          slug: "RECOVERY_ON_TIMER_EXPIRE",
          ar: "لا يرد",
          en: "Does not respond"
        },
        {
          slug: "REDIRECTION_TO_NEW_DESTINATION",
          ar: "لا يرد",
          en: "Does not respond"
        },
        {
          slug: "UNALLOCATED_NUMBER",
          ar: "رقم خطاء",
          en: "Wrong number"
        },
        {
          slug: "USER_BUSY",
          ar: "الرقم مشغول",
          en: "Number is busy"
        },
    ],
    statuses_info: [
      {
        status: "NEW",
        ar_info:
          "في خلال 24 ساعة من تسجيل الطلب يقوم فريق التأكيدات بتأكيد الطلب من خلال مكالمة تأكيدية مع العميل يتم فيها التأكيد على عنوان العميل و اسم المنتج و قيمة الطلب فقط، يكون توقيت المكالمات من الساعة 8 صباحًا إلى 5 مساءًا، في حالة تسجيل الطلب على الموقع قبل الساعة 4 مساءا يتم تأكيد الاوراد في نفس اليوم ليخرج للتسليم في اليوم التالي، أما في حالة التسجيل بعد الساعة 4 مساءًا يتم تأكيده في اليوم القادم ليخرج للتسليم في اليوم الذي يليه",
        en_info:
          "Within 24 hours of registering the order, the confirmation team confirms the order through a confirmation call with the customer. In this call, only the customer's address, product name, and order value are confirmed. The call timings are from 8 AM to 5 PM. If the order is registered on the website before 4 PM, the orders are confirmed the same day and sent for delivery the next day. However, if registered after 4 PM, it is confirmed the next day and sent for delivery the day after.",
        arabic: "طلب جديد",
        english: "New Order",
      },
      {
        status: "1st NA",
        ar_info:
          "في حالة عدم الرد على المكالمة  الأولى او طلب اعادة الاتصال في وقت لاحق , نقوم بمحاولة ثانية في اليوم الذي يلي و في حال عدم الرد نقوم بمحاولة ثالثة في اليوم الذي يليه الى خمس محالولات  بعدها يتم الغاء الطلب عدم الرد",
        en_info:
          "In case there's no answer to the first call or a request to call back later, we make a second attempt the next day. If there's still no response, a third attempt is made the day after that, up to five attempts. Afterward, the order is canceled due to no response.",
        arabic: "المحاولة الاولى",
        english: "First Attempt",
      },
      {
        status: "2nd NA",
        ar_info:
          "في حالة عدم الرد على المكالمة  الأولى او طلب اعادة الاتصال في وقت لاحق , نقوم بمحاولة ثانية في اليوم الذي يلي و في حال عدم الرد نقوم بمحاولة ثالثة في اليوم الذي يليه الى خمس محالولات  بعدها يتم الغاء الطلب عدم الرد",
        en_info:
          "In case there's no answer to the first call or a request to call back later, we make a second attempt the next day. If there's still no response, a third attempt is made the day after that, up to five attempts. Afterward, the order is canceled due to no response.",
        arabic: "المحاولة الثانية",
        english: "Second Attempt",
      },
      {
        status: "3rd NA",
        ar_info:
          "في حالة عدم الرد على المكالمة  الأولى او طلب اعادة الاتصال في وقت لاحق , نقوم بمحاولة ثانية في اليوم الذي يلي و في حال عدم الرد نقوم بمحاولة ثالثة في اليوم الذي يليه الى خمس محالولات  بعدها يتم الغاء الطلب عدم الرد",
        en_info:
          "In case there's no answer to the first call or a request to call back later, we make a second attempt the next day. If there's still no response, a third attempt is made the day after that, up to five attempts. Afterward, the order is canceled due to no response.",
        arabic: "المحاولة الثالثة",
        english: "Third Attempt",
      },
      {
        status: "Cancel - No Answer",
        ar_info:
          "في حالة عدم الرد على المكالمة  الأولى او طلب اعادة الاتصال في وقت لاحق , نقوم بمحاولة ثانية في اليوم الذي يلي و في حال عدم الرد نقوم بمحاولة ثالثة في اليوم الذي يليه الى خمس محالولات  بعدها يتم الغاء الطلب عدم الرد",
        en_info:
          "In case there's no answer to the first call or a request to call back later, we make a second attempt the next day. If there's still no response, a third attempt is made the day after that, up to five attempts. Afterward, the order is canceled due to no response.",
        arabic: "الغاء الطلب عدم الرد",
        english: "Order Canceled - No Answer",
      },
      {
        status: "call back",
        ar_info:
          "في حالة عدم الرد على المكالمة  الأولى او طلب اعادة الاتصال في وقت لاحق , نقوم بمحاولة ثانية في اليوم الذي يلي و في حال عدم الرد نقوم بمحاولة ثالثة في اليوم الذي يليه الى خمس محالولات  بعدها يتم الغاء الطلب عدم الرد",
        en_info:
          "In case there's no answer to the first call or a request to call back later, we make a second attempt the next day. If there's still no response, a third attempt is made the day after that, up to five attempts. Afterward, the order is canceled due to no response.",
        arabic: "التواصل في وقت لاحق",
        english: "Contact Later",
      },
      {
        status: "NEED CHECK",
        ar_info:
          "في حالة عدم الرد على المكالمة  الأولى او طلب اعادة الاتصال في وقت لاحق , نقوم بمحاولة ثانية في اليوم الذي يلي و في حال عدم الرد نقوم بمحاولة ثالثة في اليوم الذي يليه الى خمس محالولات  بعدها يتم الغاء الطلب عدم الرد",
        en_info:
          "In case there's no answer to the first call or a request to call back later, we make a second attempt the next day. If there's still no response, a third attempt is made the day after that, up to five attempts. Afterward, the order is canceled due to no response.",
        arabic: "الطلب قيد المراجعة",
        english: "Order Under Review",
      },
      {
        status: "Call back After 11:00AM",
        ar_info:
          "في حالة عدم الرد على المكالمة  الأولى او طلب اعادة الاتصال في وقت لاحق , نقوم بمحاولة ثانية في اليوم الذي يلي و في حال عدم الرد نقوم بمحاولة ثالثة في اليوم الذي يليه الى خمس محالولات  بعدها يتم الغاء الطلب عدم الرد",
        en_info:
          "In case there's no answer to the first call or a request to call back later, we make a second attempt the next day. If there's still no response, a third attempt is made the day after that, up to five attempts. Afterward, the order is canceled due to no response.",
        arabic: "التواصل في وقت لاحق",
        english: "Contact Later After 11:00AM",
      },
      {
        status: "Cancel - CIM",
        ar_info:
          "تم الغاء الطلب بسبب عدم رغبة العميل في الحصول على المنتج المسجل في الطلب او رفض ذكر سبب الالغاء",
        en_info:
          "The order was canceled due to the customer's lack of interest in obtaining the product listed in the order or refusal to state the reason for cancellation.",
        arabic: "الغاء الطلب - لم يعد بحاجة المنتج",
        english: "Cancel - No Longer Wants the Product",
      },
      {
        status: "Cancel - Price",
        ar_info:
          "تم الغاء الطلب بسبب عدم توفر المال الكافي للطلب او لم يعجبه سعر الطلب",
        en_info:
          "The order was canceled due to insufficient funds or the customer did not like the price.",
        arabic: "الغاء الطلب - السعر",
        english: "Cancel - Price Issue",
      },
      {
        status: "Cancel - Didn't need the order",
        ar_info:
          "تم الغاء الطلب بسبب مواصفات المنتج او اختلاف بين الاعلان و المنتج المتوفر",
        en_info:
          "The order was canceled due to product specifications or a discrepancy between the advertisement and the available product.",
        arabic: "الغاء الطلب - المنتج",
        english: "Cancel - Product Issue",
      },
      {
        status: "Cancel - Others",
        ar_info:
          "تم الغاء الطلب بسبب السفر او عدم توفر العميل او اسباب اخرا غير واضحة",
        en_info:
          "The order was canceled due to reasons such as traveling, unavailability of the customer, or other unclear reasons.",
        arabic: "الغاء الطلب - بسبب اخر",
        english: "Cancel - Other Reasons",
      },
      {
        status: "Cancel ID",
        ar_info:
          "تم الغاء الطلب بسبب عدم توفر رقم البطاقة الشخصية او رفض اعطائه للشركة",
        en_info:
          "The order was canceled due to the unavailability of a personal ID number or refusal to provide it to the company.",
        arabic: "الغاء الطلب - عدم وجود رقم هوية",
        english: "Cancel - No ID Number",
      },
      {
        status: "Cancel wrong number",
        ar_info: "تم الغاء الطلب الرقم خطاء او الليس الشخص المطلوب",
        en_info:
          "The order was canceled because the number is incorrect or it's not the intended person.",
        arabic: "الغاء الطلب - الرقم خاطئ",
        english: "Cancel - Incorrect Number",
      },
      {
        status: "cancel wrong person",
        ar_info: "تم الغاء الطلب الرقم خطاء او الليس الشخص المطلوب",
        en_info:
          "The order was canceled because the number is incorrect or it's not the intended person.",
        arabic: "الغاء الطلب - الشخص خاطئ",
        english: "Cancel - Wrong Person",
      },
      {
        status: "Cancel - Didn't Request",
        ar_info: "تم الغاء الطلب بسبب لم يطلب الطلب او ليس صاحب الطلب",
        en_info:
          "The order was canceled because it was not requested or it's not the actual owner of the order.",
        arabic: "الغاء الطلب - لم يطلب الطلب",
        english: "Cancel - Didn't Place the Order",
      },
      {
        status: "Cancel Delivery Fees",
        ar_info: "تم الغاء الطلب بسبب عدم رغبته في دفع اجور التوصيل",
        en_info:
          "The order was canceled due to an unwillingness to pay delivery fees.",
        arabic: "الغاء الطلب - اجور التوصيل",
        english: "Cancel - Delivery Fees",
      },
      {
        status: "Cancel - Corona (COVID-19)",
        ar_info: "تم الغاء الطلب بسبب مرض كوفد و توابعه الصحية",
        en_info:
          "The order was canceled due to the COVID-19 illness and its health consequences.",
        arabic: "الغاء الطلب - مرض كوفد",
        english: "Cancel - COVID-19 Concerns",
      },
      {
        status: "Cancel don't have Card",
        ar_info: "تم الغاء الطلب بسبب عدم توفر طريقة دفع لدى العميل",
        en_info:
          "The order was canceled because the customer doesn't have a payment method available.",
        arabic: "الغاء الطلب - ليس لديه بطاقة او وسيلة دفع",
        english: "Cancel - No Payment Method",
      },
      {
        status: "Payment Order",
        ar_info:
          "يتم تاكيد الطلب لكن بشرط الدفع الالكتروني قبل تسليم الطلب لشركة التوصيل بسبب عدم استلامه لاكثر من طلبين من المتجر",
        en_info:
          "The order is confirmed, but with the condition of electronic payment before handing the order to the delivery company due to not receiving more than two orders from the store.",
        arabic: "تم تاكيد الطلب - بشرط الدفع الالكتروني",
        english: "Order Confirmed - Conditional on Electronic Payment",
      },
      {
        status: "Confirmed",
        ar_info:
          "بعد تأكيد الطلب، يتم بدأ احتساب موعد استلام العميل طبقا للبلد التابع لها",
        en_info:
          "After confirming the order, the estimated delivery time for the customer is calculated based on the country of residence.",
        arabic: "تم تاكيد الطلب",
        english: "Order Confirmed",
      },
      {
        status: "Dispatch",
        ar_info:
          "جاري تجهيز الشحنة وفي انتظار شركة الشحن لاستلام المنتج من المخزن الخاص بنا",
        en_info:
          "The shipment is being prepared and awaiting the courier company to collect the product from our warehouse.",
        arabic: "قيد التجهيز للشحن",
        english: "Preparing for Dispatch",
      },
      {
        status: "NEW Confirm",
        ar_info:
          "بعد تأكيد الطلب، يتم بدأ احتساب موعد استلام العميل طبقا للبلد التابع لها",
        en_info:
          "After confirming the order, the estimated delivery time for the customer is calculated based on the country of residence.",
        arabic: "تم تاكيد الطلب",
        english: "Order Newly Confirmed",
      },
      {
        status: "Paid",
        ar_info:
          "بعد تأكيد الطلب، يتم بدأ احتساب موعد استلام العميل طبقا للبلد التابع لها",
        en_info:
          "After confirming the order, the estimated delivery time for the customer is calculated based on the country of residence.",
        arabic: "تم تحصيل الطلب",
        english: "Order Paid",
      },
      {
        status: "Cancel Combine",
        ar_info: "الطلب قيد المراجعة",
        en_info: "The order is under review.",
        arabic: "الطلب قيد المراجعة",
        english: "Order Review",
      },
      {
        status: "pending payment",
        ar_info:
          "بعد تأكيد الطلب، يتم تعليق الطلب لمدة 48 ساعة الى ان يتم الدفع و في حال عدم الدفع يتمر ارسال الطلب الدفع عند الاستلام و يتم بدأ احتساب موعد استلام العميل طبقا للبلد التابع لها، والمواعيد الرسمية للتوصيل حسب الجدول التالي :",
        en_info:
          "After confirming the order, the order is suspended for 48 hours until payment is made. If no payment is received, the order defaults to cash on delivery, and the estimated delivery time for the customer is calculated based on the country of residence. The official delivery schedule is as follows:",
        arabic: "تم تاكيد الطلب - بنتظار الدفع الالكتروني",
        english: "Order Confirmed - Awaiting Electronic Payment",
      },
      {
        status: "Cancel - Duplicate",
        ar_info: "تم الغاء الطلب بسبب تكرار الطلب",
        en_info: "The order was canceled due to a duplicate order.",
        arabic: "الغاء الطلب - التكرار",
        english: "Cancel - Duplicate Order",
      },
      {
        status: "cancel NSA",
        ar_info: "تم الغاء الطلب بسبب المنطقة او البلد غير مخدومة",
        en_info:
          "The order was canceled because the region or country is not served.",
        arabic: "الغاء الطلب - منطقة غير مخدومة",
        english: "Cancel - Unserviceable Area",
      },
      {
        status: "Cancel Whatsapp",
        ar_info: "تم الغاء الطلب عبر رسائل الوتس اب",
        en_info: "The order was canceled via WhatsApp messages.",
        arabic: "الغاء الطلب - عبر واتس اب",
        english: "Cancel via WhatsApp",
      },
      {
        status: "Cancel reject previous order",
        ar_info:
          "يتم الغاء الطلب بسب تسجيل لنفس العميل طلبين او اكثر و عدم استلام الطلب",
        en_info:
          "The order is canceled due to the same customer registering two or more orders and not receiving the order.",
        arabic: "الغاء الطلب - رفض استلام الطلب لعدة مرات",
        english: "Cancel - Repeated refusal to receive the order",
      },
      {
        status: "Pending",
        ar_info:
          "يتم تعليق الطلب في عدة حالات وهي  عناون غير واضح ,خلل في الطلب,طلب الزابون مؤجل بناء على طلب العميل و سيتم معالجة الطلب خلال 24 ساعة",
        en_info:
          "The order is suspended in several cases: unclear address, error in the order, customer's request is deferred based on the customer's request, and the order will be processed within 24 hours.",
        arabic: "تم تعليق الطلب",
        english: "Order Suspended",
      },
      {
        status: "Out For delivery",
        ar_info:
          "الطلب تم تسليمه لشركة الشحن وسوف يصل للعميل خلال مواعيد الشحن الرسمية، ويتواصل المندوب مع العميل لتحديد يوم مناسب",
        en_info:
          "The order has been handed over to the shipping company and will reach the customer during the official shipping times. The representative will coordinate with the customer to determine a suitable day.",
        arabic: "قيد التوصيل",
        english: "Out For Delivery",
      },
      {
        status: "Out for delivery",
        ar_info:
          "الطلب تم تسليمه لشركة الشحن وسوف يصل للعميل خلال مواعيد الشحن الرسمية، ويتواصل المندوب مع العميل لتحديد يوم مناسب",
        en_info:
          "The order has been handed over to the shipping company and will reach the customer during the official shipping times. The representative will coordinate with the customer to determine a suitable day.",
        arabic: "قيد التوصيل",
        english: "Out For Delivery",
      },
      {
        status: "Returned",
        ar_info:
          "يتم ارجاع الطلب الى المخزن من قبل شركة التوصيل بعد نفاذ كل الطرق و المحاولات لتوصيل الطلب",
        en_info:
          "The order is returned to the warehouse by the delivery company after exhausting all means and attempts to deliver the order.",
        arabic: "تم ارجاع الطلب",
        english: "Order Returned",
      },
      {
        status: "Delivered",
        ar_info:
          "تم تسليم الطلب للعميل، ويتم تحديث حالة الطلب خلال 24 ساعة بعد استلام العميل، ويظهر ربح الطلب في خانة الربح المتوقع خلال نفس يوم التحديث، وبعد مرور 7  أيام بيتم تحويل الربح لخانة الربح القابل للصرف",
        en_info:
          "The order has been delivered to the customer. The order status is updated within 24 hours after the customer receives it. The order's profit appears in the expected profit box on the same day of the update. After 7 days, the profit is transferred to the redeemable profit box.",
        arabic: "تم تسليم الطلب",
        english: "Order Delivered",
      },
      {
        status: "out of stock",
        ar_info: "نفذ المخزون وسيتم معالجة الطلب خلال 3-5 ايام كحد اقصى",
        en_info:
          "Stock is depleted, and the order will be processed within a maximum of 3-5 days.",
        arabic: "نفذ المخزون",
        english: "Out of Stock",
      },
      {
        status: "reschedule",
        ar_info:
          "جاري تجهيز الشحنة وفي انتظار شركة الشحن لاستلام المنتج من المخزن الخاص بنا",
        en_info:
          "Preparing the shipment and waiting for the shipping company to pick up the product from our warehouse.",
        arabic: "طلب مؤجل حسب رغبة الزبون",
        english: "Order postponed as per customer's wish",
      },
      {
        status: "Reschedule",
        ar_info:
          "جاري تجهيز الشحنة وفي انتظار شركة الشحن لاستلام المنتج من المخزن الخاص بنا",
        en_info:
          "Preparing the shipment and waiting for the shipping company to pick up the product from our warehouse.",
        arabic: "طلب مؤجل حسب رغبة الزبون",
        english: "Order postponed as per customer's wish",
      },
      {
        status: "unpacked",
        ar_info:
          "جاري تجهيز الشحنة وفي انتظار شركة الشحن لاستلام المنتج من المخزن الخاص بنا",
        en_info:
          "Preparing the shipment and waiting for the shipping company to pick up the product from our warehouse.",
        arabic: "قيد التجهيز للشحن",
        english: "Preparing for Shipping",
      },
      {
        status: "reconfirm",
        ar_info: "نفذ المخزون وسيتم التواصل مع العميل عند توافر المخزون",
        en_info:
          "Stock is depleted, and we will contact the customer when it's available.",
        arabic: "تم الغاء الطلب بسب عدم توفر المنتج",
        english: "Order was canceled due to product unavailability",
      },
      {
        status: "cancel",
        ar_info: "يتم الغاء الطلب بناء على طلب الزبون او بسبب خلل تقني او فني",
        en_info:
          "The order is canceled based on the customer's request or due to a technical or functional issue.",
        arabic: "تم الغاء الطلب بعد التاكيد",
        english: "Order was canceled after confirmation",
      },
      {
        status: "paid",
        ar_info:
          "تم تسليم الطلب للعميل، ويتم تحديث حالة الطلب خلال 24 ساعة بعد استلام العميل، ويظهر ربح الطلب في خانة الربح المتوقع خلال نفس يوم التحديث، وبعد مرور 7  أيام بيتم تحويل الربح لخانة الربح القابل للصرف",
        en_info:
          "The order has been delivered to the customer. The order status is updated within 24 hours after the customer receives it. The order's profit appears in the expected profit box on the same day of the update. After 7 days, the profit is transferred to the redeemable profit box.",
        arabic: "تم تحصيل الطلب",
        english: "Order Collected",
      },
      {
        status: "pending",
        ar_info: "جاري التجهيز للشحن",
        en_info: "Preparing for shipping.",
        arabic: "جاري التجهيز للشحن",
        english: "Preparing for Shipping",
      },
      {
        status: "Under return Process",
        ar_info: "قيد الارجع",
        en_info: "Under return process.",
        arabic: "قيد الارجع",
        english: "Under Return Process",
      },
    ],
    statuses_obj: {},
    call_statuses_obj: {},
    i18n: {
      en: {
        store_title: "Store Title",
        open_link: "Open Link",
        auto_sync_orders: "Auto Sync Orders",
        auto_sync_products: "Auto Sync Products",
        accountAppsSettings: "Apps Settings",
        app_account_settings: "Apps settings",
        setup_your_app_account_settings: "Setup apps settings related to your account",
        integrations: "Apps",
        zidProducts:"Zid Products",
        ninjaProducts:"Ninja Products",
        ordertracking:"Tracking Orders",
        track:"Track",
        search_by_document_number:'Search By Document Number',
        fees_per_fulfilled_order:"Fees Per Fulfilled Order",
        order_tracking:"Tracking URL",
        prepaid_orders:'Prepaid Orders',
        sure_dublicate_form:"do you sure duplicate this form ?",
        confirm_dublicate: 'confirm dublicate',
        confirm_dublicate_form: 'Confirm Dublicate Form',

        Repeat_the_form:"Repeat the form",
        duplicates:"Forms iterations",
        is_sync:"Is Sync",
        most_popular:"Most Popular", 
        offer_color:"Font Offer Color",
        selectTrigger:"Select Trigger",
        free_delivery:"Free Delivery",
        Submit_button_color:"Submit Button Color",
        button_font_color:"Submit Button Font Color",
        title_color:"Title Color",
        title_font_size:"Title Font Size",
        style_form:"Update Style Form",
        planList:"Plans List",
        planPrice:"Subscription",
        forms:"Forms",
        form_list:"Forms List",
        createForm:"Create Form",
        fromNameInput:"Form Name",
        descriptionForm: "Form Description",
        formLanguage:"Form Language",
        addField:"Add Field",
        fieldLabel:"Field Label",
        fieldType:"Field Type",
        removeField:"Remove Field",
        addOffer:"Add Offer",
        saveForm:"Save Form",
        offerlabel:"Offer Label",
        addProduct:"Add Product",
        removeProduct:"Remove Product",
        removeOffer:"Remove Offer",
        trackSocialMedia:"Do you need to track social media platforms?",
        addPlatform:"Add Platform",
        selectPlatform:"Select Platform",
        removePlatform:"Remove Platform",
        selectEvent:"Select Event",
        selectPixel:"Select Pixel",
        is_phone:"Is This Field a Phone Number ?",
        successURL:"Success URL",
        quantity:"Quantity",
        store_name:"Store Name",
        is_required:"Is Required ?",
        order_duration:"The period specified for registering the order",
        name:"Name",
        firstPhoneNumber:"First Phone Number",
        secondPhoneNumber:"Second Phone Number",
        selectCategory:"Select Category",
        showField:"Show Field",
        hideField:"Hide Field",
        hideOffer:"Hide Offer",
        showOffer:"Show offer",
        hideProduct:"Hide Product",
        showProduct:'Show Product',
        Field:"Field",
        offer:"Offer",
        platform:"Platform",
        product:"Product",
        formFields:{
          "Name": "Name",
          "First Number Phone": "First Phone Number",
          "Second Number Phone":"Second Number Phone",
          "Address":"Address",
          "Country":"Country",
          "City":"City",
          "Note":"Note",

        },
        fieldOrder:"Field Order",
        chooseColor:"Choose Color",
        resubmitBlockDuration:"Resubmit block duration(in hour)",
        formList:"Forms List",
        updateForm:"Update Form",

        fieldsType:{
          Name:'Name',
          FIRST_NUMBER_PHONE:'First Phone Number',
          SECOND_NUMBER_PHONE:'Second Phone Number',
          COUNTRY:'Country',
          CITY:'City',
          ADDRESS: 'Address',
          NOTE:'Note',
        },

        addPixel:'Add Pixel',
        pixel:'Pixel',
        Results: " Results",
        Result: " Result",
        IpAddress:"IP Address",
        SubmittedDate:"Submitted Date",
        FormId:"Form ID",
        fieldValue:"Field Value",
        submit_label:"Submit button label",
        price_id:"Price ID",
        plan_slug:"Plan Slug",
        compare_price:"Compare Price",
        price_id:"Price ID",
        feature:"Feature en",
        feature_ar:"Feature ar",

        features:"Features",
        features_ar:"Features ar",

        add_plan:"Add Plan",
        add_feature:"Add Feature en",
        add_feature_ar:"Add Feature ar",

        updatePlan:"Update Plan",
        form_number:"Forms Number",
        form_submission:"Number of forms submission",
        form_views:"Number form views",
        form_count:"Forms Count",
       
        call_center_note:'Call Center Note',

        free_delivery:'Free Delivery',
        store_name_invalid:'Store Name invalid',
        account_search:`Search for an account`,
        book_a_place_now:`Book Your Place Now`,
        ninja_sellers_camp_description:`Ninja Sellers Camp a chance to launch your E-commerce business seriously`,
        ninja_sellers_camp:`Ninja Sellers Camp`,
        registerForms:'Registration Forms',
        funding_percentage:`Funding Percentage`,
        payment_attachment_url:`Upload Proof of Payment`,
        po_reset:`Reset PO Approval`,
        proof_of_payment:`Upload Proof of Payment`,
        search_product_description:`Search by product description`,
        by_tags:'By Tag',
        show_expired_products:`Show expired offers`,
        show_all_products:`Show all products`,
        related_products:'Related Products',
        create:`Create`,
        update:`Update`,
        save:`Save`,
        ship_to_country:`Ship to country`,
        download_all_photos_videos_to_your_pc: "Download all media",
        ar_language:`Arabic Language`,
        en_language:`English Language`,
        intro_video:"Intro Video",
        net_profit_calculator:`Net Profit Calculator`,
        net_profit_calculator_details:`Details`,
        net_profit_calculator_item:`Item`,
        net_profit_calculator_result:`Result`,
        ads_cost:`Adverts Total Cost`,
        confirmed_orders_count:`Confirmed Orders Count`,
        delivered_orders_count:`Delivered Orders Count`,
        items_count:`Items Sold Count`,
        cost_of_goods:`Cost of Goods`,
        investment:`Investment Total`,
        sales:`Sales Revenue`,
        call_center_fees:`Call Center Fees`,
        shipping_fees:`Shipping Fees`,
        cod_fees:`COD Fees`,
        total_fees:`Total Fees`,
        net_profit:`Net Profit`,
        roi:`Return On Investment`,
        items_per_order:`Item per order ratio`,
        lead_cost:`Order Ads Cost`,
        sale_price:`Order Sale Price`,
        product_height:`Height`,
        product_length:`Length`,
        product_width:`Width`,
        product_weight:`Weight`,
        "min_order_quantity|desc":`Sort Desc ⬇️ By Min. Order Quantity`,
        "price|desc":`Sort Desc ⬇️ By Price`,
        "time_to_warehouse|desc":`Sort Desc ⬇️ By Shipping Duration`,
        "min_order_quantity|asc":`Sort Asc ⬆️ By Min. Order Quantity`,
        "price|asc":`Sort Asc ⬆️ By Price`,
        "time_to_warehouse|asc":`Sort Asc ⬆️ By Shipping Duration`,
        'remaining_leads|asc':`Sort Asc ⬆️ By Leads Count`, 
        'remaining_leads|desc':`Sort Desc ⬆️ By Leads Count`,
        from_lead_count:'From Leads Count',
        to_lead_count:'To Leads Count',
        sort_by:`Sort By`,
        from_price:`Filter prices from`,
        to_price:`Filter prices to`,
        from_wharehouse_time:`Filter Shipping Duration from`,
        to_wharehouse_time:`Filter Shipping Duration to`,
        suggested_sale_price:`Suggested Sale Price`,
        expiry_date:`Active till`,
        start_a_new_purchaseOrder:`New Order`, 
        pieces:`Pieces`,
        title_ar:`Arabic Title`,
        title_en:`English Title`,
        description_ar:`Arabic Description`,
        description_en:`Enlish Description`,
        label_ar:`Arabic`,
        label_en:`Englis`,
        min_order_quantity:`Min. Order Qty.`,
        time_to_warehouse:`Shipping Duration`,
        add_media:`Add Media`,
        add_tag:`Add Tag`,
        add_price:`Add Price`,
        is_active:`Active`,
        is_not_active:`Not Active`,
        purchaseOrderPaymentMethods:`PO Payment Methods`,
        wholesaleProducts:`Wholesale Products`,
        wholesaleProductsAdmin:`Products Admin`,
        open_file:`Open File`,
        not_fully_paid:`Not fully paid`,
        updates_timeline:`Updates Timeline`,
        purchase_order_payment_method_id:`Payment Method`,
        po_payment_method_details:`Payment Method Details`,
        wholesale_status_id:`Status`,
        po_paypal:`Paypal`,
        po_wise:`Wise`,
        po_vodafone:`Vodafone Cash`,
        po_payoneer:`Payoneer`,
        po_bank:`Bank Transfer`,
        po_wallet:`Ninja Wallet`,
        received_quantity:`Received Quantity`,
        invoice_total:`Invoice Total`,
        paid_total:`Paid`,
        po_new:`New`,
        po_processing:`Processing`,
        po_price_quotation_issued:`Quotation Issued`,
        po_purchased:`Purchased`,
        po_approved:`Approved`,
        po_rejected:`Rejected`,
        po_paid:`Paid`,
        po_shipped:`Shipped`,
        po_recieved:`Recieved`,
        po_canceled:`Canceled`,
        rejected_quotation_successfully:`Quotation rejected`,
        confirm_rejection_state_reason:`Confirm rejecting price quotation and share reason with us please`,
        confirm_reject:`Conform Rejection`,
        rejected_reason:`Rejection Reason`,
        rejected_reason_details:`Rejection Reason Details`,
        reject_price:`Reject because of price`,
        reject_shipping_duration:`Reject because of shipping duration`,
        reject_product_mismatch:`Reject because of product mismatch`,
        reject_other:`Reject because of another reason`,
        has_new_messages:`Has new messages`,
        product_sku:`Product SKU`,
        crm_po_key:`Internal Key`,
        admin_note:`Platform Notes`,
        uid:`Purchase Order Identifier`,
        filter_results:`Filter Results`,
        no_accepted_quotation: `Not accepted`,
        no_quotation_price: `No final price`,
        price_quotation_accepted:`Price Quoutation Accepted`,
        current_po_status:`Current Purchase Order Status`,
        verification_email_sent:`Verification code sent to email`,
        accepted_quotation_successfully:`Price Quotation accepted successfully`,
        code_is_invalid:`Verification code is invalid`,
        we_sent_code_to_email:`We have sent a code to your email`,
        verification_code:`Verification Code`,
        confirm_accept:`Confirm Acceptance`,
        note_if_accept_quotation:`Accepting price quotation is final and cant be reverted, total cost will be deducted from your balance immediately`,
        are_you_ready_to_accept_quotation:`Are you ready to accept the quoutation?`,
        accept:`Accept`,
        updated_at:`Updated at`,
        new:`New`,
        po_submit:`Submit`,
        po_show_details:`Show Details`,
        date_shipped_at:`Shipped at`,
        date_recieved_at:`Recieved at`,
        in_warehouse_date:`Expected arrival date`,
        accepted_quotation_status:`Quotation Status`,
        accepted_quotation:`Accepted`,
        pending_quotation:`Pending`,
        date_created:`Order Date`,
        updated_at:`Last Update`,
        quotation_quantity:`Final Quantity`,
        quotation_price:`Final Price`,
        po_item_title_en:`Product Title English`,
        po_item_title_ar:`Product Title Arabic`,
        po_item_quantity:`Quantity`,
        po_item_price:`Target price per unite`,
        po_item_description:`Product Important Attributes`,
        origin:`Country of origin`,
        destination:`Destination Country`,
        po_item_source_url:`Product Source URL`,
        purchaseOrder:`Purchase Order`,
        purchaseOrders:`Purchase Orders`,
        export_items:`Export Item`,
        remaining_leads:`Order`,
        usdt_trc20_address:`TRC20 Wallet Address`,
        add_new_order:'Add new order',
        support:'Support',
        suggestions:'Suggestions',
        video: "Video",
        article: "Article",
        account: "Account",
        total_orders: "Total Orders",
        percentage_from_total_orders: "Percentage from Total Orders",
        add_new_settings: "Add New Settings",
        country: "Country",
        settings: "Settings",
        percentage: "Percentage (%)",
        commission: "Commission",
        close: "Close",
        add_settings: "Add Settings",
        update: "Update",
        order_details: "Order Details",
        decrease_quantity: "Decrease Quantity",
        increase_quantity: "Increase Quantity",
        net_profit_per_unite: "Net Profit Per Unit",
        total: "Total",
        net_profit: "Net Profit",
        net_profit_in_usd: "Net Profit in USD",
        order_summary: "Order Summary",
        count_of_selected_products: "Count of Selected Products",
        shipping_cost: "Shipping Cost",
        sales_tax: "Sales Tax",
        total_net_profit: "Total Net Profit",
        usd: "USD",
        cost_of_order_additional_services: "Cost of Order Additional Services",
        total_amount_due: "Total Amount Due",
        customer_information: "Customer Information",
        free_delivery_explaination: "To notify the customer that the shipping is free or to add shipping costs and notify them",
        item_sold_with_free_delivery: "Item Sold with Free Delivery",
        second_phone_number: "Second Phone Number",
        city: "City",
        shipping_fees: "Shipping Fees",
        address: "Address",
        address_hint: "Area, Street Name, Building Number, Apartment Number",
        business_name_explained: "Your business name or the page or company name you use for selling",
        notes: "Notes",
        continue_shopping: "Continue Shopping",
        place_order: "Place Order",
        required: "Required",
        max_20_chars: "Max 20 Characters",
        cart_empty: "Cart is Empty",
        name_required: "Name is Required",
        phone_required: "Phone Number is Required",
        country_required: "Country is Required",
        city_required: "City is Required",
        address_required: "Address Required",
        business_name_required: "Business Name is Required",
        business_name_required_in_english: "Please Enter the Business Name in English",
        welcome_to_ninja_sellers: "Welcome to Ninja Sellers Platform",
        confirm_email_instructions: "Please confirm your email via the link sent to your email",
        send_confirmation_email: "Send Confirmation Email",
        contact_support_via_whatsapp: "For support, you can contact us via WhatsApp",
        please_input_code: "Please enter the code",
        wrong_code_try_again: "Wrong code, please try again",
        phone_verification_success: "Phone number verified successfully",
        link_sent_to_email: "A link has been sent to your email",
        call_center_fees: "Call Center Fees",
        shipping_fees_vendor: "Delivery Fees",
        cod_fees: "Cash On Delivery Fees",
        sales_tax_vendor: "VAT (Value Added Tax)",
        final_invoice_total: "Final Invoice Total",
        contact_us_through_email: "Contact Us via Email",
        ninja_sellers_copyright: "All rights reserved to Ninja Sellers Company",
        terms_and_conditions: "Terms and Conditions",
        follow_us_on_social_media: "Follow us on Social Media",
        order_number: "Order Number",
        order_data: "Order Date",
        delivery_date: "Delivery Date",
        order_status: "Order Status",
        customer_name: "Customer Name",
        phone_number: "Phone Number",
        tracking_number: "Tracking Number",
        alternative_phone: "Alternative Phone",
        gross_total: "Gross Total",
        net_profit: "Net Profit",
        dispatch_date: "Dispatch Date",
        delivery_delayed_to: "Delivery postponed to",
        order_status_details: "Order Status Details",
        cancel_details: "Cancellation Details",
        order_details_lead: "Order Details",
        edit_lead: "Edit Order",
        send_message_lead: "Send Message",
        rate_order: "Rate Order",
        business_name: "Business Name",
        the_product: "The Product",
        quantity: "Quantity",
        unite_sold_price: "Price per Unit",
        remove_order_from_import: "Remove Order from Import",
        order_details_import: "Order Details",
        seller: "Seller",
        products: "Products",
        send_to_crm: "Send to CRM",
        confirm_delete: "Confirm Deletion",
        delete_order: "Delete Order",
        order_details: "Order Details",
        basic_information: "Basic Information",
        additional_fees: "Additional Fees",
        order_status_followup: "Order Status Tracking",
        calls_followup: "Call Tracking",
        close: "Close",
        order_id_order_rating: "Order Number | Order Rating",
        order_number_send_message_about_order: "Order Number | Send a Message Regarding the Order",
        message: "Message",
        basic_info: "Basic Info",
        follow_up_order_status: "Order Status Tracking",
        follow_up_calls: "Call Tracking",
        price: "Price",
        profit: "Profit",
        search: "Search",
        notifications: "Notifications",
        my_products: "My Products",
        how_to_start_course: "Course on How to Start",
        cart: "Shopping Cart",
        finish_placing_order: "Complete Purchase",
        my_account: "My Account",
        close_menu: "Close Menu",
        ninja_sellers_services: "Ninja Sellers Services",
        ninja_sellers_academy: "Ninja Sellers Academy",
        ninja_sellers_treasures: "Ninja Sellers Treasures",
        ignore: "Ignore",
        link: "Link",
        add_new_settings: "Add New Settings",
        account: "Account",
        settings: "Settings",
        percentage: "Percentage (%)",
        add_settings: "Add Settings",
        update: "Update",
        welcome_to_ninja_sellers: "Welcome to Ninja Sellers Platform",
        confirm_your_email: "Confirm Your Email",
        email_confirmed_successfully: "Email Confirmed Successfully",
        next: "Next",
        please_confirm_your_email_by_clicking_link_sent_to_your_email: "Please confirm your email by clicking the link sent to your email",
        send_confirmation_email: "Send Confirmation Email",
        you_can_reach_support_on_whatsapp: "For support, you can contact us on WhatsApp",
        ready_to_learn_ecom: "Are you ready to learn e-commerce?",
        all_what_you_need_to_learn: "Everything you need to learn about commerce, marketing, and benefiting from the platform",
        ninja_sellers: "Ninja Sellers",
        we_provide_it_in_one_place: "we offer it at Ninja Academy in one place and",
        free: "Free",
        start_now: "Start Now",
        secret_required: "Please enter the secret number",
        wrong_secret_try_again: "Wrong secret, please try again",
        phone_confirmed: "Your number has been confirmed",
        link_sent_to_your_email: "A link has been sent to your email",
        total_net_profit_order: "Total Net Profit",
        total_net_profit_usd_order: "Total Net Profit in USD",
        product_name: "Product Name",
        quantity: "Quantity",
        total: "Total",
        total_profit: "Total Profit",
        total_profit_in_usd: "Profit in USD",
        piece: "Piece",
        limited_offer: "Limited Offer",
        net_profit: "Net Profit",
        offer_starts_in: "Offer starts in",
        left_to_offer_end: "Left to offer end",
        day: "Day",
        hour: "Hour",
        minutes: "Minute",
        second: "Second",
        left: "Left",
        limited_quantity: "Limited Quantity",
        limited_offer_price_will_be_back_to: "This limited offer, the price will revert to",
        after: "After",
        this_product_price_will_go_down_to: "This product price will decrease to",
        next_flash_sale: "Next Flash Sale",
        add_to_cart: "Add to Cart",
        list_of_invoices_by_country: "List of Invoices by Country",
        total_orders: "Total Orders",
        subvendor_call_fees: "Subvendor Call Service Fees",
        subvendor_shipping_fees: "Subvendor Delivery Fees",
        subvendor_cod_fees: "Subvendor Cash on Delivery Service Fees",
        subvendor_tax_fees: "Value Added Tax",
        subvendor_total_fees: "Subvendor Total Invoice",
        call_or_call_trial: "Call / Call Attempt",
        call_trial: "Call Attempt",
        settings_according_to_order_status: "Settings According to Order Status",
        call_center_fees_per_confirmed_order: "Call Center Fees per Confirmed Order",
        call_center_fees_per_no_answer_cancel: "Call Center Fees for Orders Canceled Due to No Answer from Customer",
        call_center_fees_per_order_canceled_by_customer: "Call Center Fees for Orders Canceled by Customer",
        call_center_fees_per_oreder_canceled_because_of_wrong_number: "Call Center Fees for Orders Canceled Due to Wrong Number",
        call_center_fees_per_delivered_order: "Call Center Fees for Every Delivered Order (Fill in the value for the call center service for every delivered order)",
        delivery_fees_for_undelivered_order: "Delivery Fees for Each Undelivered Order",
        delivery_fees_for_deliverd_order_in_addition_to_platform_fees: "Delivery fees for each order delivered, in addition to the existing delivery fees on the platform (this field is filled if there's an agreement with the customer to charge only for the delivered order)",
        vat_added_to_collected_amount_of_order: "Value added tax on the total collected amount of the order",
        cod_collection_fees: "Cash on Delivery collection fees",
        selected_if_agreement_on_return_fees_same_as_deliverd_fees: "Selected if there's an agreement with the customer to charge the return order with the same delivery fees for each city",
        close: "Close",
        add_settings: "Add settings",
        update: "Update",
        please_verify_your_number: "Please verify your phone number",
        verify_your_phone_number: "Verify your phone number",
        verify_phone_number: "Verify phone number",
        country_code: "Country code",
        phone_number: "Phone number",
        send_secret_code: "Send secret code",
        secret_code: "Secret code",
        confirm_phone_number: "Confirm the number",
        cancel: "Cancel",
        phone_number_reqired: "Phone number required",
        please_input_secret_code: "Please enter the secret code",
        wrong_secret_code_try_again: "The secret code is wrong, please try again",
        phone_number_confirmed_successfully: "Your phone number has been confirmed successfully",
        please_verify_your_email: "Please verify your email",
        send_verification_email: "Send verification email",
        a_link_is_sent_to_your_email: "A link has been sent to your email",
        identity_confirmation: "Identity confirmation",
        information_to_confirm_your_identity: "Information to confirm your identity for your account",
        add_id_and_submit_for_verification: "Add an ID and submit it for verification",
        confirm_account_identity: "Confirm account identity",
        upload_id_image: "Upload ID or residence card image",
        upload_id_or_passport_image: "Upload passport/ID image",
        name_as_in_passport: "Name as in the personal ID or passport",
        id_verification_is_being_proccessed: "Your ID verification request is being processed",
        cancel: "Cancel",
        add: "Add",
        name_as_in_passport_short: "Name in the passport",
        confirmation_image: "Confirmation image",
        review_is_done: "Review is done",
        approved: "Approved",
        rejected: "Rejected",
        note: "Note",
        ur_data_is_sent_for_verification: "Your data has been sent for verification",
        service_pages: "Service pages",
        start_a_new_service_page: "Start a new service page",
        edit_page: "Edit page",
        page_title: "Page title",
        menu_title: "Menu title",
        contact_link: "Contact link",
        update: "Update",
        click_here_to_contact_us: "Click here to contact us",
        videos_and_articles_settings: "Manage articles and videos",
        academy_settings: "Academy management",
        add_article: "Add article",
        add_section: "Add section",
        add_keyword: "Add keyword",
        all_users: "All users",
        selected_users: "Select specific accounts",
        all_active: "Active accounts",
        use_sku_recent: "Accounts that sold a product in the last 48 hours",
        use_sku_month: "Accounts that sold a product in the last month",
        sections_settings: "Manage sections",
        keywords_settings: "Manage keywords",
        new_account: "New account",
        affiliate_code: "Affiliate code",
        copy_affiliate_link: "Copy affiliate link",
        personal_information: "Personal information",
        you_can_edit_your_personal_info_and_some_settings: "You can edit your personal information and some settings",
        name: "Name",
        phone_number: "Phone number",
        edit_information: "Edit information",
        change_password: "Change password",
        you_can_change_your_password_here: "You can change your password here",
        request_password_change_by_email: "Request password change via email",
        refered_account: "Referred accounts",
        your_referals: "Your referrals",
        accounts_count: "Number of accounts",
        orders_count: "Number of orders",
        business_account: "Business account",
        business_account_info_and_settings: "Information and settings of your business account",
        allow_platform_to_change_pricing_on_confirm: "Allow the platform to change prices upon order confirmation",
        notifications_by_email: "Notifications via email",
        withdrawal_methods: "Withdrawal methods",
        withdrawal_methods_info: "Your withdrawal methods information and settings",
        add_withdrawal_method: "Add new withdrawal method",
        click_here_to_verify_your_account: "Please click here to verify your account",
        withdrawal_method: "Withdrawal method",
        withdrwal_method_tool: "Earnings receipt method",
        payment_method_name: "Your custom name for the payment method",
        phone_number_for_account: "Phone number for the account",
        account_identifier: "Account identifier",
        paypal_email: "Paypal account email",
        bank_name: "Bank name",
        bank_account_holder_name: "Bank account holder's name",
        account_number_iban: "Bank account number (IBAN)",
        switft_code: "SWIFT code",
        special_for_us_bank_accounts: "Specific to US bank accounts",
        account_number: "Account number",
        currency: "Currency",
        bank_address: "Bank address",
        detailed_address: "Detailed address",
        city: "City",
        name_as_in_passport: "Name as in Passport",
        request_is_evaluated_in_24_hours: "The request for adding a payment method is evaluated within 24 business hours",
        add: "Add",
        payment_method: "Payment Method",
        review_is_done: "Review Completed",
        approved: "Approved",
        rejected: "Rejected",
        note: "Note",
        personal_information: "Personal Information",
        change_password: "Change Password",
        affiliates: "Referrals",
        business_account: "Business Account",
        payment_methods: "Payment Methods",
        identity_verification: "Personal Identity Verification",
        paypal_email_is_required: "PayPal email is required",
        phone_number_is_required: "Phone number is required",
        all_bank_account_fields_required: "All bank account details are required",
        payment_method_submitted_for_approval: "Payment method has been submitted for approval",
        update_success: "Updated successfully",
        please_verify_your_account_to_add_a_payment_method: "Please verify your account first to add a payment method",
        you_have_a_pending_verification_request: "You have a pending verification request",
        you_have_no_approved_identity_verification_request: "You don't have any approved identity verification request",
        all_accounts: "All Accounts",
        manage_platfrom_accounts: "Manage Platform Accounts",
        search: "Search",
        active_accounts: "Active Accounts",
        accounts_with_withdrawals: "Accounts with Earnings Received",
        choose_country_to_show_products: "Select a country to display your products in",
        soon: "Coming Soon",
        products_count: "Number of Products",
        flash_offers: "Flash Offers",
        show_all_offers: "Show All Offers",
        wait_for_best_offers: "Stay tuned for the best offers",
        best_selling_products: "Best Selling Products",
        show_all_best_sellers: "Show All Best Sellers",
        latest_products: "Latest Products",
        show_all_latest_products: "Show All Latest Products",
        all_products: "All Products",
        show_all_products: "Show All Products",
        close: "Close",
        free: "Free",
        all_id_verification_requests: "All ID Verification Requests",
        manage_id_verification_requests: "Manage ID Verification Requests",
        pending_verification: "Pending Review",
        review_done: "Review Completed",
        approval_done: "Approval Done",
        notes: "Notes",
        update: "Update",
        cancel: "Cancel",
        import_orders: "Import Orders",
        all_import_orders_details: "All details of your orders",
        new_account: "New Account",
        your_orders: "Your Orders",
        search_by_phone_name_document_number: "Search by name, phone number, shipment number, or order number",
        from_date: "From Date",
        to_date: "To Date",
        orders: "Orders",
        all_orders_details: "All details of orders on the platform",
        no_delivery_date: "Without delivery date",
        account_profit: "Account Profits",
        account_name: "Account Name",
        account_id: "Account ID",
        total_account_profits: "Total",
        total_ready_account_profits: "Ready",
        total_pending_account_profits: "Pending",
        close: "Close",
        accounts: "Accounts",
        affiliated_with_account: "Affiliated with Account",
        show_profits: "Show Profits",
        email_notifications: "Email Notifications",
        payment_methods: "Payment Methods",
        record_transaction: "Record Transaction",
        payment_method: "Payment Method",
        review_done: "Review Completed",
        has_been_approved: "Approved",
        has_been_rejected: "Rejected",
        transaction_value: "Transaction Value",
        note: "Note",
        export_accounts_list: "Download Accounts List",
        update_seminar_link: "Update Seminar Link",
        seminar_link: "Seminar Link",
        link: "Link",
        all_settings: "All Settings",
        affiliate_settings_management: "Affiliate Settings Management",
        add_new_settins: "Add New Settings",
        account: "Account",
        country_id: "Country ID",
        percentage: "Percentage",
        commission: "Commission",
        edit: "Edit",
        soon: "Coming Soon",
        id_photo: "ID Photo",
        name_as_in_passport: "Name as in Passport",
        request_done: "Request Completed",
        last_update: "Last Update",
        account_id_verification: "Account ID Verification",
        download_model_import_table: "Download Orders Model File",
        select_orders_import_file: "Open Orders File",
        confirm_orders_import: "Confirm Importing All Orders",
        orders: "Orders",
        number_of_orders_found: "Number of Orders Found",
        search: "Search",
        export_orders: "Download Orders",
        affiliate_code: "Affiliate Code",
        copy_affiliate_link: "Copy Affiliate Link",
        your_email_has_been_verified_you_can_start_working: "Your email has been verified successfully. You can now log in and start working.",
        your_email_verification_didnt_work_please_contact_support: "Email verification failed. Please try again or contact support.",
        login: "Login",
        information: "Information",
        register: "Register",
        first_name: "First Name",
        last_name: "Last Name",
        residency_country: "Country of Residency",
        your_phone_number_with_example: "Your Phone Number (e.g. 966505707808)",
        phone_number_should_be_active_on_whatsapp: "The number should be active on WhatsApp for communication",
        i_agree_to_terms_and_conditions: "I agree to the terms and conditions after reviewing them",
        terms_and_conditions: "Terms and Conditions",
        next: "Next",
        register_with_google: "Register with Google",
        or_register_using: "Or register using",
        confirm_password: "Confirm Password",
        login_with_google: "Login with Google",
        or_login_via: "Or login via",
        your_phone_number: "Your Phone Number",
        your_whatsapp_number: "Your WhatsApp Number",
        your_facebook_account_link: "Your Facebook Account Link",
        sold_countries_history: "Countries you have previously sold in",
        ads_used_before: "Marketing and advertising methods you use",
        total_monthly_ads_spend: "How much do you invest in ads monthly?",
        average_weekly_orders: "Average number of orders you sell weekly",
        residency_country_required: "Country of Residency is required",
        first_name_required: "First name is required",
        last_name_required: "Last name is required",
        phone_required: "Phone number is required",
        enter_correct_phone_number: "Please enter a valid phone number",
        email_sent: "Email has been sent",
        email_or_password_is_wrong: "Email or password is incorrect",
        please_register_before_login: "Please register before trying to log in",
        account_created_logining_in: "Account successfully created, logging in...",
        please_confirm_password: "Please confirm the password",
        confirm_password_not_matching: "Password does not match",
        name_required: "Name is required in this format",
        email_required: "Email is required for this registration method",
        terms_acceptance_required: "Please agree to the terms and conditions",
        not_found: "Not found",
        none: "None",
        facebook_ads: "Facebook Sponsored Ads",
        google_ads: "Google Sponsored Ads",
        tiktok_ads: "TikTok Sponsored Ads",
        instagram_ads: "Instagram Sponsored Ads",
        snapchat_ads: "Snapchat Sponsored Ads",
        youtube_ads: "YouTube Sponsored Ads",
        whatsapp_marketing: "WhatsApp Marketing",
        facebook_groups_marketing: "Facebook Groups Marketing",
        facebook_market_marketing: "Facebook Marketplace Marketing",
        sales_0: "Zero - I'm still a beginner in the field",
        sales_50_to_100: "50-100 orders weekly",
        sales_101_to_300: "101-300 orders weekly",
        sales_301_to_500: "301-500 orders weekly",
        sales_501_to_800: "501-800 orders weekly",
        sales_801_to_1000: "801-1000 orders weekly",
        sales_more_than_1000: "More than 1000 orders weekly",
        ad_budget_none: "None",
        ad_budget_0_to_500: "$0-500",
        ad_budget_501_to_1000: "$501-1000",
        ad_budget_1001_to_5000: "$1001-5000",
        ad_budget_5000_to_10000: "$5000-10000",
        ad_budget_more_than_10000: "More than $10000",
        you_are_qualified_and_added_to_newsletter_list: "You have been qualified for the draw and successfully added to the mailing list",
        there_is_a_problem_please_contact_support: "There is an issue, please contact support",
        register: "Login",
        your_notifiations: "Your Notifications",
        your_account_and_orders_notification: "Notifications related to your orders and account",
        mark_all_notifications_as_read: "Mark all notifications as read",
        platform_notifications: "Platform Notifications",
        home: "Home",
        products: "Products",
        download_all_photos_to_your_pc: "Download all photos to your computer",
        product_name: "Product Name",
        product_code: "Product Code",
        product_price: "Product Price",
        net_profit: "Net Profit",
        product_is_available: "Product is available",
        number_of_pieces_availble: "Number of pieces available",
        offer_will_start_after: "The offer will start after",
        day: "Day",
        hour: "Hour",
        minute: "Minute",
        second: "Second",
        the_price_of_this_product_will_drop_to: "The price of this product will drop to",
        left_for_this_offer: "Remaining for this offer",
        this_offer_will_end_then_price_will_go_back_to: "This offer is temporary and the price will revert to",
        after: "After",
        quantity: "Quantity",
        reduce_quantity: "Reduce Quantity",
        increase_quantity: "Increase Quantity",
        remove_from_cart: "Remove from Cart",
        add_to_your_products: "Add to Your Products",
        remove_from_your_products: "Remove from Your Products",
        finish_order: "Complete Order",
        product_is_available_in_the_following_countries: "Product is available in the following countries",
        product_description: "Product Description",
        product_video: "Product Video",
        similar_products: "Similar Products",
        back_to_products: "Back to Products",
        added_to_your_products: "Added to your products",
        removed_from_your_products: "Removed from your products",
        reports_about_your_orders: "Reports about your orders",
        from_date: "From Date",
        to_date: "To Date",
        out_for_delivery_date_from: "Out for delivery date from",
        out_for_delivery_date_to: "Out for delivery date to",
        report_for_account: "Report for account",
        manjam_ninja_orders: "Manjam Ninja Orders",
        load_report: "View Report",
        export_report: "Download Report",
        total_orders: "Total Orders",
        orders_in_last_30_days: "Orders in the last 30 days",
        profits: "Profits",
        order: "Order",
        invoices_total: "Total Invoices",
        confirmation_rate: "Confirmation Rate",
        delivery_rate: "Delivery Rate",
        statistics_for_accounts_orders: "Statistics for accounts' orders",
        total: "Total",
        show_more: "Show More",
        orders_distribution_by_current_status: "Order distribution by current status",
        average_profit_per_order: "Average profit per order",
        expected_confirmation_rate: "Expected Confirmation Rate",
        order_distribution_by_country: "Order distribution by country",
        status_and_delivery_rates_per_country: "Order status and delivery rates by country",
        the_10_best_seller_products_in_each_country: "Top 10 best-selling products in each country",
        best_seller_products_statuses_and_delivery_rate: "Order statuses and delivery rates for best-selling products",
        pick_a_country_to_load_report: "Choose a country to view the report",
        calculate_expected_profit_by_product: "Calculate expected profit by product",
        pick_a_country_and_a_product_to_load_report: "Choose a country and a product to view the report",
        net_profit: "Net Profit",
        expected_confirm_rate: "Expected Confirmation Rate",
        expected_delivery_rate: "Expected Delivery Rate",
        total_expected_profit: "Total Expected Profit",
        total_ad_spend_in_usd: "Total Ad Spend in USD",
        orders_count: "Number of Orders",
        no_data_to_export: "No data to download",
        pick_a_country: "Choose a Country",
        soon: "Soon",
        search: "Search",
        no_results_please_try_again: "No results, please try again",
        submit_a_complaint: "Submit a Complaint",
        you_submit_all_your_complaint_details_to_get_help: "You can submit all your complaint details here so we can assist you",
        subject_or_order_id: "Subject or Order ID",
        complaint_details: "Complaint Details",
        send: "Send",
        submit_a_suggestion: "Submit a Suggestion",
        submit_suggestion_details: "You can submit all the details of your suggestion here and how you would use it in your work",
        subject: "Subject",
        suggestions_details: "Suggestion Details",
        already_sent: "Already Sent",
        amounts_available_to_withdraw_except_what_is_withdrawn_already: "Amounts available to withdraw excluding previously withdrawn amounts",
        usd: "USD",
        total_expected_profit: "Total Expected Profit",
        pending_profits_available_to_withdraw: "Amounts available for withdrawal after a period",
        total_profit_from_orders: "Total Profit from Orders",
        amounts_available_to_withdraw: "Amounts Available for Withdrawal",
        orders: "Orders",
        expected_profit_from_orders: "Expected Profit from Orders",
        orders_delivered_since_less_than_7_days: "Orders delivered less than 7 days ago",
        total_profits_from_affiliation: "Total Profits from Referrals",
        expected_profit_from_affiliation: "Expected Profit from Referrals",
        withdrawal_requests: "Withdrawal Requests",
        your_withdrawal_requests: "Your Withdrawal Requests",
        click_here_to_verify_your_account: "Click here to verify your account",
        click_here_to_add_payment_method: "Click here to add a payment method",
        withdrawal_request: "Withdrawal Request",
        fees_deducted_from_your_profits_as_per_payment_method: "Fees and commissions are deducted from your earnings according to the profit collection method specified in your account",
        withdraw_request: "Withdraw Request",
        profit_available_to_withdraw: "Amount available for withdrawal",
        profit_withdrawal_method: "Profit Collection Method",
        requested_withdrawal_amount_in_usd: "Requested withdrawal amount in USD",
        withdrawal_request_is_proccessed_in_48_hours: "The withdrawal request is processed within 48 business hours",
        cancel: "Cancel",
        add: "Add",
        payment_method: "Payment Method",
        transaction_status: "Transaction Status",
        transaction_date_time: "Transaction Date and Time",
        under_review: "Under Review",
        rejected: "Rejected",
        was_approved: "Approved",
        note: "Note",
        transactions_and_paid_profits: "Withdrawn Profits and Payments",
        what_was_already_paid_from_your_profits: "What has already been paid from your profits",
        amount: "Amount",
        status: "Status",
        date: "Date",
        please_verify_your_account_to_request_withdrawal: "Please verify your account first to proceed with the withdrawal",
        you_have_a_pending_verification_request: "You have a pending verification request",
        you_have_no_approved_verification_request: "You have no approved verification requests",
        you_have_no_approved_payment_method: "You do not have an approved payment method",
        all_payment_methods_are_under_review: "All payment methods are under review",
        you_dont_have_approved_payment_method: "You do not have an approved payment method",
        you_dont_have_enough_profits_to_withdraw: "There isn't sufficient balance available for withdrawal",
        you_cant_submit_one_more_withdrawal_request: "You can't submit another withdrawal request",
        no_bank_withdrawal_under_500_usd: "Bank withdrawal cannot be requested for amounts less than 500 USD",
        no_withdrawal_allowed_before_25_ready_profits: "Withdrawal cannot be requested unless there's at least 25 USD available for withdrawal",
        please_refer_to_support_to_activate_withdrawals: "Please contact support to activate withdrawal requests",
        notes: "Notes",
        all_settings: "All Settings",
        manjam_settings_management: "Manjam Settings Management",
        add_new_settings: "Add New Settings",
        account: "Account",
        number: "Number",
        country_id: "Country ID",
        percentage: "Percentage",
        edit: "Edit",
        slider_settings: "Slider Settings",
        hero_promo_country_count: "You can now sell in 15 Arab and African countries from your location by working on platform products or importing your own products",
        hero_country_arabic: "Saudi Arabia",
        hero_country_kuwait: "Kuwait",
        hero_country_oman: "Oman",
        hero_country_bahrain: "Bahrain",
        hero_country_iraq: "Iraq",
        hero_country_alardn: "Jordan",
        hero_country_lebya: "Libya",
        hero_country_felesteen: "Palestine",
        hero_country_misr: "Egypt",
        hero_country_emarat_arabia: "United Arab Emirates",
        hero_country_qatar: "Qatar",
        hero_country_lebnan: "Lebanon",
        hero_country_maghreb: "Morocco",
        hero_country_sanghal: "Senegal",
        hero_country_sahil: "Côte d'Ivoire",
        hero_country_mr: "Mauritania",
        partner_dream_ecommerce: "The partner that makes your e-commerce dream a reality",
        ninja_seller_academy: "Learn everything about e-commerce with Ninja Sellers Academy",
        ninja_seller_offer: "What Ninja Sellers will offer you",
        ninja_seller_offer_detail: "Now the dream becomes reality. With us, you can start your e-commerce business from anywhere in the world, offering all services from shipping from China to our local warehouses, then confirming the order and delivering it with local delivery companies, and then collecting from the customer. We provide thousands of products and you can benefit from all services and request the import of your own goods, and we handle all services.",
        why_ninja_seller: "Why Ninja Sellers?",
        why_ninja_seller_description: `
                Because we have over 8 years of experience in e-commerce with cash on delivery and we have an infrastructure in all the countries available on the platform. We also offer the best prices with the best service for all ninjas. <br>
                
                Therefore, we provided you with two ways of working:<br>
                1. Working on your own goods, where everything you need to import your own goods is taken care of, from customs clearance and more.<br>
                2. Working on the goods available on the platform, where thousands of products are available with the possibility to determine the selling price without any restrictions on you.<br>
              `,
        project_starting_title: "What do I need to start my e-commerce business?",
        project_starting_description: "You need to develop your marketing skills and focus only on marketing the products.",
        project_marketting_product: "Focus on marketing your product",
        project_marketting_description: "Whether you are working on the products available on the platform or your own imported products, we will take care of all your needs from order registration to delivery to the customer's door until transferring profits to your account.",
        project_wihtout_capital: "Lowest risk percentage",
        project_capital_decription: "If you are working with platform products, you won't incur any costs unless the order is delivered. And if you decide to import your own goods, you pay when placing orders without any monthly subscriptions and get a single price including storage and delivery as well.",
        project_net_profit: "High net profit",
        project_profit_decription: "You can sell and determine the profit that suits you. You also get to determine the appropriate profit for you on all products and in all countries.",
        project_step_ecommerce: "You can sell on your goods or platform goods",
        project_step_ecommerce_descr: "We provide you with thousands of profitable products on the platform in all countries and provide the service of importing your goods from the country of origin to any of the countries available on the platform while ensuring all services.",
        service_section_title: "The services we offer for importers of their own goods",
        service_section_sub_title: "",
        service_import_from_china: "Import your goods from China",
        service_import_from_china_description: "",
        service_store_import_orders: "Store and prepare orders",
        service_store_import_orders_decription: "",
        service_confirm_orders: "Confirm and follow up orders",
        service_confirm_orders_decription: "",
        service_local_delivery: "Delivery with local delivery companies",
        service_local_delivery_decription: "",
        service_cash_on_delivery: "Cash on delivery collection service",
        service_cash_on_delivery_description: "",
        ninja_seller_start_now: "Seize the opportunity now and join the Ninja Sellers army",
        ninja_how_web_work: "How the platform works",
        ninja_creat_account: "Create your account on the Ninja Sellers website for free",
        ninja_select_country_product: "If you are a beginner, start learning for free from the Ninja Sellers Academy everything about e-commerce",
        ninja_fill_order: "Select the countries and products you want to sell, either from the products available on the platform or by importing your own goods.",
        ninja_transfered_amount: "Start placing orders on the platform, and we will take care of everything until profits are collected and transferred to you",
        ninja_waiting_for_title: "What are you waiting for to join the Ninja Sellers team?",
        ninja_waiting_for_description: "Ninja Sellers assists anyone who decides to start their e-commerce business with cash on delivery. It enables selling in multiple countries as it offers thousands of products. Additionally, it provides a service to import your goods from any country to the ones available on the platform. Ninja Sellers covers everything you need for importing your goods, offering a comprehensive infrastructure to kickstart your project without any obstacles or costs, ensuring minimal risk.",
        ninja_waiting_for_sub_description: "Ninja Sellers is a team with extensive experience that will support you in everything you need to start working in e-commerce in more than one market from your location, without any establishment expenses or fixed costs. We will provide you with the right product, and if you want a specific product, we will import any product you want from any country to all our warehouses available in the countries on the platform. We manage all logistical services, customs clearance, shipping, storage, order confirmation, order delivery with local delivery companies, collection services, and cash on delivery to the customer, transferring the net profit in record time. In short, Ninja Sellers provides you with a complete infrastructure to start your e-commerce directly from your place effortlessly. Our platform allows you to manage and track orders, a vast variety of products in multiple countries, a rapid local shipping service for your customers with a cash on delivery option, and collecting your profits in a record time without any complications. Don't hesitate to start; everything you need is now available in one place with a team specialized in e-commerce with expertise and qualifications that enable you to sell in multiple countries at the same time.",
        servicePages: "Service Pages",
        menu_label: "Menu Title",
        desktop: "Computer",
        mobile: "Phone",
        order: "Order",
        slides: "Slider settings",
        order: "Order",
        deleteBtn: "Yes, delete",
        areYouSureOfDelete: "Are you sure you want to delete |item|?",
        academyKeywords: "Keywords",
        academyCategories: "Categories",
        keywords: "Keyword",
        label: "Label",
        edit: "Edit",
        title: "Title",
        image: "Image",
        category: "Category",
        keyword: "Keywords",
        type: "Type",
        body: "Content",
        video_url: "Video URL",
        categories: "Categories",
        articles: "Articles",
        academy: "Academy",
        subVendorSettings: "Sub-vendor Settings",
        manjamSettings: "Manjam Settings",
        affilaiteSettings: "Affiliate Settings",
        subVendorProducts: "Your Products",
        idVerifications: "Verification",
        notificationsAdmin: "Platform Notifications",
        notify: "Send Notifications",
        reports: "Reports",
        transactions: "Payments",
        paymentMethods: "Payment Methods",
        dashboard: "Products",
        catalog: "Your Favorite Products",
        shipping: "Shipping",
        tickets: "Support",
        wallet: "Wallet",
        account: "My Account",
        store: "Your Store",
        accounts: "Accounts",
        requests: "Withdrawal Requests",
        leadsMaster: "All Orders",
        user_exists_login: "Account is already registered, try logging in if you own the account",
        item_name: "Product Name",
        price: "Price",
        quantity: "Quantity",
        order_total: "Total Amount",
        your_details: "Details",
        item_total: "Total",
        continue_shopping: "Continue Shopping",
        submit_order: "Finalize Purchase",
        cart: "Shopping Cart",
        order_now: "Order Now",
        finish_order: "Finish Order",
        time_left: "Time Left",
        details: "Product Details",
        country_choose: "Please choose your country",
        items_in_order: "Purchases",
        name: "Name",
        phone_number: "Phone Number",
        add_to_cart: "Add to Cart",
        thank_you: "Your order has been sent successfully",
        tomorrow: "Come back tomorrow for our latest offers",
        deliveryJO: "3 Dinars Delivery Fees",
        deliverySA: "Add another product to get a free veneer",
        deliveryJOS: "You got free shipping for your order",
        deliverySAS: "You got a free veneer",
        delivery_total: "Delivery Fees",
        delivery_free: "You got free delivery for your order",
        sold: "Sold",
        piece: "Piece",
        added_to_cart: "Added to Cart",
        size_color: "Size/Color",
        cancel: "Close",
        total: "Total",
        lowestJO: "Lowest prices in Jordan",
        lowestSA: "Lowest prices in Saudi Arabia",
        dismiss: "Close",
        search: "Search",
        back: "Home",
        tax: "Tax Included",
        start: "Start Now",
        emailSoftware: "Emails",
        campaigns: "Campaigns",
        campaign: "Campaign",
        lists: "Lists",
        list: "List",
        templates: "Templates",
        template: "Template",
        accountCreated: "Account created, contact the manager for access",
        sent: "Sent",
        opened: "Opened",
        clicked: "Clicked",
        lastChange: "Last Update",
        agent: "Employee",
        access: "Access",
        userRole: "User Type",
        users: "Users",
        user: "Regular User",
        admin: "Manager",
        superadmin: "General Manager",
        userEmail: "User Email",
        userName: "Username",
        close: "Close",
        position: "Job Title",
        submitBtn: "Save",
        reload: "Reload",
        subject: "Subject",
        fromName: "Sender's Name",
        fromEmail: "Sender's Email",
        replyTo: "Reply To",
        lastUpdated: "Last Updated",
        sendingActive: "Sending...",
        inDraft: "Draft",
        alreadySent: "Already Sent",
        sendIconTooltip: "Send Now",
        scheduleIconTooltip: "Schedule for Later",
        valid_email: "Please enter a valid email",
        leads: "Leads",
        subscribers: "Subscribers' Emails",
        suppression: "Suppression",
        offices: "Offices",
        loginWithGoogle: "Login with Google",
        register: "Register",
        forgetPassword: "Forgot Password?",
        sendResetEmail: "Send Reset Email",
        please_use_google_to_login: "Please use Google to login",
        user_not_found: "User not found",
        listings: "Listings",
        applicationsCenter: "Applications Center",
        cv: "CV",
        cvs: "CVs",
        resume: "Resume",
        resumes: "Resumes",
        coverletters: "Cover Letters",
        appsettings: "App Settings",
        applications: "Applications",
        inbox: "Inbox",
        corporate: "Corporate",
        billing: "Billing",
        receipts: "Receipts",
        plan: "Plan",
        upgradePlan: "Upgrade",
        addToShortList: "Add to Shortlist",
        shortlists: "Shortlists",
        note: "Note",
        from: "From",
        to: "To",
        latest: "Latest",
        specialty: "Specialty",
        city: "City",
        state: "State",
        verified: "Verified",
        prefer: "Prefers Email",
        limit: "Limit",
        description: "Description",
        captcha: "Please enter the code shown in the image",
        wrong_captcha: "You entered the wrong code",
        only_numbers: "Only numbers are allowed",
        progressTitle: "Progress",
        pdfReportsIconTooltip: "Generate report",
        generateReport: "Generate report",
        clearChart: "Reset",
        cant_be_imported: "This employee cannot be imported",
        domain_not_allowed: "This domain is not allowed",
        allLegend: "All Legend",
        specialAccess: "Grant user special ministry page access",
        email: "Email",
        password: "Password",
        login: "Login",
        send: "Send",
        home: "Home",
        max_retries: "You exceeded the maximum allowed attempts",
        wrong_code: "Incorrect code entered, please try again",
        expired: "Session expired",
        user_already_exists: "This user has been imported previously",
        success: "Operation successful",
        not_found: "Item not found",
        all_fields_required: "All fields are required",
        item_name_missing: "A name is missing for one of the items",
        organisation: "Ministry Overview",
        strategy: "Ministry Strategy",
        orgProgress: "Ministry Progress Measurement",
        orgStructure: "Ministry Organizational Structure",
        userSettings: "User Settings",
        mySpace: "Personal Space",
        notifications: "Notifications",
        progress: "Goals and Achievements",
        report: "Report",
        managment: "Dashboard",
        employees: "Import Employees",
        employeesSub: "Manage Employees",
        charts: "Performance Chart",
        approvals: "My Approvals",
        user: "My Account",
        orgStructureSetting: "Edit Organizational Structure",
        settings: "Settings",
        pubReports: "Publish Report",
        logout: "Logout",
        search: "Search",
        totalProgress: "Total Achievements",
        goals: "Goals",
        goal: "Goal",
        keyResult: "Key Result",
        keyResults: "Key Results",
        initiative: "Initiative",
        initiatives: "Initiatives",
        trend: "Trend",
        progress: "Main Goals and Achievements",
        mainResult: "Results/Initiatives",
        status: "Status",
        change: "Modify",
        editIconTooltip: "Edit",
        deleteIconTooltip: "Delete",
        addGoal: "Add Goal",
        addGoalTitle: "Add Goal",
        editGoalTitle: "Edit Goal",
        parentGoal: "Associated Parent Goal",
        deleteGoalTitle: "Delete Goal",
        addKeyResult: "Add Result",
        addKeyResultTitle: "Add Result",
        editKeyResultTitle: "Edit Result",
        deleteKeyResultTitle: "Delete Result",
        addInit: "Add Initiative",
        addInitTitle: "Add Initiative",
        editInitTitle: "Edit Initiative",
        deleteInitTitle: "Delete Initiative",
        viewGoalTitle: "Goal Details",
        viewKeyResultTitle: "Key Result Details",
        viewInitTitle: "Initiative Details",
        cancelBtn: "Cancel",
        addBtn: "Add",
        updateBtn: "Update",
        add: "Add",
        update: "Modify",
        delete: "Delete",
        deleteMessage: "Are you sure you want to permanently remove this item and all related data?",
        startValue: "Starting Value",
        targetValue: "Target Value",
        unite: "Measurement Unit",
        currentValue: "Current Value",
        eight: "Contribution Value",
        quarter: "Quarter",
        meters: "Meters",
        dollar: "US Dollar",
        riyal: "Saudi Riyal",
        rank: "Rank",
        number: "Number",
        mbps: "Mbps",
        gbps: "Gbps",
        percentage: "%",
        quarter_one: "First Quarter",
        quarter_two: "Second Quarter",
        quarter_three: "Third Quarter",
        quarter_four: "Fourth Quarter",
        required: "Required",
        upload: "Upload File",
        confidential: "Confidential",
        normal: "Normal",
        fileType: "File Type",
        files: "Files",
        date: "Date",
        new: "New",
        theVision: "The Vision",
        theMission: "The Mission",
        theMessage: "The Message",
        usersSettings: "User Types Settings",
        updateUser: "Update User",
        platformSettings: "System Settings",
        thresholdSettings: "Threshold Settings",
        uniteSettings: "Measurement Units Settings",
        fileTypeSettings: "Document Confidentiality Classification Settings",
        allowedFilesSettings: "Allowed File Types Settings",
        AddThreshold: "Add Threshold",
        name: "Name",
        percentageWord: "Percentage",
        saveSetting: "Save Settings",
        slug: "Storage Name (no space)",
        arabic: "Arabic",
        english: "English",
        AddUnite: "Add Unit",
        hundredError: "Should be less than 100",
        AddFileType: "Add Classification",
        addMainLevel: "Add Main Position",
        addBelow: "Add Subordinate Position",
        phoneNumber: "Phone Number",
        importUser: "Import User and Create Account",
        employeeData: "Employee Information",
        employee: "Employee",
        accept: "Approve",
        type: "Type",
        reject: "Reject",
        rejectMessage: "Rejection Note",
        acceptedNotification: "Approved on",
        rejectNotification: "Rejected",
        submissionNotification: "Needs Review",
        deletionNotification: "Deleted",
        pending: "Pending Review",
        approved: "Approved",
        there: "There",
        createNewReport: "Create New Report",
        dones: "Achievements",
        todos: "Plans",
        supports: "Needs Support",
        comments: "Comments",
        reportName: "Report Name",
        fromDate: "From Date",
        toDate: "To Date",
        newReportNotification: "New Report Titled",
        by: "By",
        submitReport: "Submit Report",
        deleteReport: "Delete Report",
        updateReport: "Update Report",
        uniteThresholds: "Unify Settings for all Achievement Categories",
        myReports: "My Reports",
        employeesReports: "Employee Reports",
        all: "All",
        totals: "Total Achievements",
        stepName: "Threshold Name",
        stepSettings: "Threshold Settings",
        instituteSettings: "Edit Ministry Strategy",
        lastSeen: "Last Updated",
        getEmailNotifications: "Receive alerts for Goals, Achievements, and Initiatives via email",
        getReportsByEmail: "Receive Report Notifications via email",
        user_does_not_exist: "This user does not exist",
        viewIconTooltip: "View Details",
        reportsIconTooltip: "View Reports",
        closeBtn: "Close",
        SMSCode: "Code Sent in Text Message",
        academyLink: "Ninja Sellers Academy",
        academyIntroTooltip: "You can enter here and learn e-commerce for free",
        seller_orders: "Track orders",
        screen_to_track:"Screen to track orders that failed to be delivered.",
        integrationSentId:"Reset Integration IDs",

      },
      ar: {
        store_title: "عنوان المتجر",
        open_link: "فتح الرابط",
        auto_sync_orders: "نقل الطلبات اوتوماتكيا الى نينجا سيلرز",
        auto_sync_products: "نقل المنتجات اوتوماتكيا الى نينجا سيلرز",
        accountAppsSettings:'تعديل اعدادات التطبيقات',
        app_account_settings:"تعديل اعدادات التطبيقات",
        setup_your_app_account_settings: "تعديل اعدادات التطبيقات المرتبطة بحسابك",
        integrations: "التطبيقات",
        zidProducts: "منتجات زد",
        ninjaProducts: "منتجات نينجا",
        ordertracking:" متابعة الطلبات",
        track:"تتبع",
        search_by_document_number:'البحث برقم الشحنة',
        fees_per_fulfilled_order:"تكاليف التجهيز لكل طلب",

        order_tracking:"رابط تتبع الطلب",
        prepaid_orders:'جميع الطلبات مدفوعة مسبقاً',
        sure_dublicate_form:"هل أنت متأكد من تكرار هذا النموذج؟",

        confirm_dublicate: 'تأكيد التكرار',
        confirm_dublicate_form: 'تاكيد تكرار النموذج',

        Repeat_the_form:"تكرار النموذج ",
        duplicates:"تكرار النماذج ",
        is_sync:"Is Sync",
        most_popular:"الاكثر طالبا", 
        offer_color:"لون خط العرض",
        selectTrigger:"اختر مشغل",
        free_delivery:"توصيل مجاني",
        store_name_invalid:'اسم المتجر غير مطايق للشروط',

        call_center_note:'ملاحظة Call center',
        Submit_button_color:"لون زر الارسال",
        button_font_color:"لون خط  زر الارسال",
        title_color:"لون العنون",
        title_font_size:"حجم خط العنوان ",
        style_form:"تعديل ستايل النموذج",
        planList:"قائمة الخطط",
        planPrice:"الاشتراك",
        forms:"النماذج",
        form_list:"قائمة النماذج",
        createForm:"أنشاء نموذج",
        fromNameInput:"اسم النموذج",
          descriptionForm: "وصف النموذج",
          formLanguage:"لغة النموذج",
          addField:"اضافة حقل",
          fieldLabel:"تسمة الحقل",
          fieldType:"نوع الحقل",
          removeField:"حذف الحقل",
          addOffer:"أضافة عرض ",
          saveForm:"حفظ النموذج",
          offerlabel:"أسم العرض",
          addProduct:"أضافة منتج",
          removeProduct:"حذف المنتج",
          removeOffer:"حذف العرض",
          trackSocialMedia:"هل انت بحاجة الى تتبع منصات التواصل الاجتماعي ؟",
          addPlatform:"أضافة منصة",
          selectPlatform:"اختر المنصة",
          removePlatform:"حذف المنصة ",
          selectEvent:"أختر الحدث",
          selectPixel:"اختر البكسل",

          is_phone:" هل هذا الحقل هو رقم الهاتف؟ ",
          successURL:"الرابط الذي ينم التوجه اليه بعد ملئ النموذج",
          quantity:"الكمية",
          store_name:"أسم المتجر",
         is_required:"مطلوب ؟",
         order_duration:"المدة المحددة لتسجيل الطلب",
         firstPhoneNumber:"رقم الهاتف الاول",
         secondPhoneNumber:"رقم الهاتف الثاني",
         selectCategory:"أختر الفئة",
         showField:"أظهار الحقل",
         hideField:"أخفاء الحقل",
         hideOffer:"اخفاء العرض",
         showOffer:"أظهار العرض",
         hideProduct:"أخفاء المنتج",
         showProduct:'أظهار المنتج',
         Field:"حقل",
         offer:"عرض",
         platform:"منصة",
         product:"منتج",
         formFields:{
          "Name": "الاسم",
          "First Number Phone": "رقم الهاتف الاول",
          "Second Number Phone":"رقم الهاتف الثاني",
          "Address":"العنوان",
          "Country":"الدولة",
          "City":"المدينة",
          "Note":"ملاحظة",
          

        },
        fieldOrder:"ترتيب الحقل",
        chooseColor:"أختر اللون",
        resubmitBlockDuration:"(بالساعة)منع تكرار الطلب لمدة",
        formList:" قائمة النماذج",
        updateForm:"تعديل النموذج",

        fieldsType:{
        Name:'الاسم',
        FIRST_NUMBER_PHONE:'الرقم الأول',
        SECOND_NUMBER_PHONE:'الرقم الثاني',
        COUNTRY:'البلد',
        CITY:'المدينة',
        ADDRESS:'العنوان',
        NOTE:'ملاحظة',
      },
        addPixel:'أضافة بكسل',
        pixel:'بكسل',
        Results: " النتائج",
        Result: " النتيجة",
        IpAddress:"عنوان الاي بي",
        SubmittedDate:"تاريخ الارسال",
        FormId:"رقم النموذج",
        fieldValue:"قيمة الحقل ",
        submit_label:"عنوان زر الارسال ",
        
        price_id:"Price ID",
        plan_slug:"Plan Slug",
        compare_price:"Compare Price",
        price_id:"Price ID",
        features:" خصائص en",
        features_ar:" خصائص ar",

        feature:"خاصية en",
        feature_ar:"خاصية ar",

        add_plan:"أضافة خطة",
        add_feature:" أضافة خاصية en",
        add_feature_ar:" أضافة خاصية ar",

        updatePlan:"تعديل الخطة ",
        form_number:"عدد النماذج",
        form_submission:"عدد الطلبات المقدمة",
        form_views:"عدد ظهور النموذج",
        form_count:"عدد النماذج",

        account_search:`بحث عن حساب`,
        book_a_place_now:`احجز مقعدك الان`,
        ninja_sellers_camp_description_chance:`فرصة`,
        ninja_sellers_camp_description:`فرصة لكل مبتدىء بتعلم التجارة الالكترونية خطوة بخطوة حتى تحقيق المبيعات مع`,
        ninja_sellers_camp_tail:`مخيم نينجا سيلرز`,
        ninja_sellers_camp:`تدريب التجارة الالكترونية`,
        registerForms:'طلبات التسجيل',
        funding_percentage:`مقدار نسبة التمويل`,
        payment_attachment_url:`تحميل اثبات الدفع`,
        po_reset:`ازالة الموافقة عن عرض السعر`,
        proof_of_payment:`تحميل اثبات الدفع`,
        search_product_description:`البحث بوصف المنتج`,
        by_tags:`بحسب القسم`,
        show_expired_products:`عرض العروض المنتهية`,
        show_all_products:`عرض جميع المنتجات`,
        related_products:`منتجات مشابهة`,
        create:`انشاء`,
        update:`تحديث`,
        save:`تخزين`,
        ship_to_country:`الدولة المراد الشحن لها`,
        download_all_photos_videos_to_your_pc: "تحميل كافة الصور والفيديو",
        ar_language:`اللغة العربية`,
        en_language:`اللغة الانجليزية`,
        intro_video:`فيديو تعريفي`,
        net_profit_calculator:`حاسبة الارباح`,
        net_profit_calculator_details:`التفاصيل`,
        net_profit_calculator_item:`الأسم`,
        net_profit_calculator_result:`النتيجة`,
        ads_cost:`اجمالي كلفة الاعلانات`,
        confirmed_orders_count:`عدد الطلبات المؤكدة`,
        delivered_orders_count:`عدد الطلبات المسلمة`,
        items_count:`عدد القطع المباعة`,
        cost_of_goods:`تكلفة البضاعة الاجمالية`,
        investment:`الاستثمار`,
        sales:`المبيعات`,
        call_center_fees:`اجور خدمة Call Center`,
        shipping_fees:`اجور التوصيل`,
        cod_fees:`اجور خدمة الدفع عند الاستلام`,
        total_fees:`اجمالي الاجور`,
        net_profit:`صافي ربح`,
        roi:`عائد على الاستثمار`,
        items_per_order:`معدل القطع لكل طلب`,
        lead_cost:`تكلفة الطلب الاعلانية`,
        sale_price:`سعر بيع الطلب`,
        product_height:`الارتفاع`,
        product_length:`الطول`,
        product_width:`العرض`,
        product_weight:`الوزن`,
        "min_order_quantity|desc":` الترتيب تنازلي ⬇️ بحسب اقل كمية للطلب`,
        "price|desc":` الترتيب تنازلي ⬇️ بحسب السعر`,
        "time_to_warehouse|desc":` الترتيب تنازلي ⬇️ بحسب وقت التسليم`,
        "min_order_quantity|asc":`الترتيب تصاعدي ⬆️ بحسب اقل كمية طلب`,
        "price|asc":`الترتيب تصاعدي ⬆️ بحسب السعر`,
        "time_to_warehouse|asc":`الترتيب تصاعدي ⬆️ بحسب وقت التسليم`,
        'remaining_leads|asc':`الترتيب تصاعدي ⬆️ بحسب عدد الطلبات`, 
        'remaining_leads|desc':` الترتيب تنازلي ⬇️ بحسب عدد الطلبات`,
        from_lead_count:'من عدد طلبات',
        to_lead_count:'الى عدد طلبات',
        sort_by:`الترتيب بحسب`,
        from_price:`الاسعار ابتداء من`,
        to_price:`الاسعار حتى`,
        from_wharehouse_time:`وقت التسليم ابتداء من`,
        to_wharehouse_time:`وقت التسليم حتى`,
        suggested_sale_price:`سعر البيع المقترح`,
        expiry_date:`فعال حتى`,
        start_a_new_purchaseOrder:`طلب شراء جديد`, 
        pieces:`قطعة`,
        title_ar:`العنوان بالعربية`,
        title_en:`العنوان بالانجليزية`,
        description_ar:`الوصف بالعربية`,
        description_en:`الوصف بالانجليزية`,
        label_ar:`العربية`,
        label_en:`الانجليزية`,
        min_order_quantity:`اقل كمية للطلب`,
        time_to_warehouse:`مدة التسليم`,
        add_media:`اضافة صور/فيديو`,
        add_tag:`اضافية تصنيف`,
        add_price:`اضافة سعر`,
        is_active:`فعال`,
        is_not_active:`غير فعال`,
        purchaseOrderPaymentMethods:`طرق الدفع لطلبات الشراء`,
        wholesaleProducts:`منتجات بالجملة`,
        wholesaleProductsAdmin:`ادارة المنتجات`,
        open_file:`فتح الملف`,
        not_fully_paid:`غير مكتمل الدفع`,
        updates_timeline:`تاريخ التحديثات`,
        purchase_order_payment_method_id:`طريقة الدفع`,
        po_payment_method_details:`تفاصيل طريقة الدفع`,
        wholesale_status_id:`الحالة`,
        po_paypal:`Paypal`,
        po_wise:`Wise`,
        po_vodafone:`Vodafone Cash`,
        po_payoneer:`Payoneer`,
        po_bank:`تحويل بنكي`,
        po_wallet:`محفظة نينجا`,
        received_quantity:`الكمية المستلمة`,
        invoice_total:`مجموع الفوترة`,
        paid_total:`مجموع الدفع`,
        po_new:`جديد`,
        po_processing:`يتم دراسة الطلب`,
        po_price_quotation_issued:`تم اصدار عرض سعر`,
        po_approved:`تم الموافقة`,
        po_purchased:`تم الشراء`,
        po_rejected:`تم الرفض`,
        po_paid:`تم الدفع`,
        po_shipped:`تم الشحن`,
        po_recieved:`تم الاستلام`,
        po_canceled:`تم الالغاء`,
        rejected_quotation_successfully:`تم رفض العرض`,
        confirm_rejection_state_reason:`تأكيد رفض عرض سعر`,
        confirm_reject:`تأكيد الرفض`,
        rejected_reason:`سبب الرفض`,
        rejected_reason_details:`تفاصيل سبب الرفض`,
        reject_price:`رفض بسبب السعر`,
        reject_shipping_duration:`رفض بسبب مدة الشحن`,
        reject_product_mismatch:`رفض بسبب عدم تطابق المنتج`,
        reject_other:`سبب اخر للرفض`,
        has_new_messages:`رسائل جديدة`,
        product_sku:`الSKU الخاص بالمنتج`,
        crm_po_key:`المعرف الداخلي`,
        admin_note:`ملاحظة المنصة`,
        uid:`معرف الطلب`,
        filter_results:`عرض النتائج`,
        no_accepted_quotation: `لم يتم الموافقة`,
        no_quotation_price: `بدون سعر نهائي`,
        price_quotation_accepted:`تم الموافقة على عرض السعر`,
        current_po_status:`الحالة الحالية لطلب الشراء`,
        verification_email_sent:`تم ارسال كود التأكيد الى الايميل الخاص بك`,
        accepted_quotation_successfully:`تم الموافقة على عرض السعر بنجاح`,
        code_is_invalid:`الرقم السري غير صحيح`,
        we_sent_code_to_email:`لقد تم ارسال ايميل الى ايميلك يحتوي على كود`,
        verification_code:`الكود السري من الايميل`,
        confirm_accept:`تأكيد الموافقة`,
        note_if_accept_quotation:`الموافقة على عرض السعر نهائي ولا يمكن التراجع عنها، ويتم خصم تكلفة عرض السعر من محفظتك بشكل مباشر`,
        are_you_ready_to_accept_quotation:`هل انت جاهز للموافقة على عرض السعر؟`,
        accept:`اوافق`,
        updated_at:`اخر تحديث`,
        new:`جديد`,
        po_submit:`تسجيل الطلب`,
        po_show_details:`التفاصيل`,
        date_shipped_at:`تاريخ الشحن`,
        date_recieved_at:`تاريخ الوصول`,
        in_warehouse_date:`التاريخ المتوقع للوصول`,
        accepted_quotation_status:`حالة عرض السعر`,
        accepted_quotation:`تم الموافقة`,
        pending_quotation:`قيد الانتظار`,
        date_created:`تاريخ الطلب`,
        updated_at:`اخر تحديث`,
        quotation_quantity:`الكمية النهائية`,
        quotation_price:`السعر النهائي`,
        po_item_title_en:`اسم المنتج باللغة الانجليزية`,
        po_item_title_ar:`اسم المنتج باللغة العربية`,
        po_item_quantity:`الكمية`,
        po_item_price:`السعر المستهدف لكل قطعة`,
        po_item_description:`اهم ميزات المنتج`,
        origin:`بلد المنشأ`,
        destination:`البلد المستهدف`,
        po_item_source_url:`رابط لمصدر المنتج`,
        purchaseOrder:`طلب شراء`,
        purchaseOrders:`طلبات شراء لمنتجاتك`,
        export_items:`تحميل بالمنتجات`,
        remaining_leads:`طلب`,
        usdt_trc20_address:`TRC20 Wallet Address`,
        add_new_order:'اضافة طلب جديد',
        support:'الدعم',
        suggestions:'المقترحات',
        model:``,
        video:`فيديو`,
        article:`مقالة`,
        account:'الحساب',
        total_orders:`مجموع الطلبات`,
        percentage_from_total_orders:`النسبة من مجمل الطلبات`,
        add_new_settings:`اضافة اعدادات جديدة`,
        country:'الدولة',
        settings:'الإعدادات',
        percentage: 'النسبة (%)',
        commission: 'العمولة',
        close: 'اغلاق',
        add_settings: 'اضافة الإعدادات',
        update: 'تحديث',
        order_details: 'معلومات الطلب',
        decrease_quantity: 'تقليل الكمية',
        increase_quantity: 'زيادة الكمية',
        net_profit_per_unite: 'صافي الربح للقطعة الواحدة',
        total: 'المجموع',
        net_profit: 'صافي الربح',
        net_profit_in_usd: 'صافي الربح بالدولار',
        order_summary: 'ملخص الطلب',
        count_of_selected_products: 'عدد المنتجات المحددة',
        shipping_cost: 'تكاليف الشحن',
        sales_tax: 'ضريبة القيمة المضافة',
        total_net_profit: 'مجموع صافي الربح',
        usd: 'دولار',
        cost_of_order_additional_services: 'تكاليف خدمات اضافية للطلب',
        total_amount_due: 'المستحق الدفع',
        customer_information: 'معلومات المشتري',
        free_delivery_explaination: 'حتى يتم اعلام العميل بان الشحن مجاني او اضافة تكاليف الشحن واعلامه بها',
        item_sold_with_free_delivery: 'تم البيع بتوصيل مجاني',
        second_phone_number: 'رقم هاتف ثاني',
        city: 'المدينة',
        shipping_fees: 'رسوم الشحن',
        address: 'العنوان',
        address_hint: 'المنطقة, اسم الشارع, رقم العقار , رقم الشقة',
        business_name_explained: 'اسمك التجاري او اسم الصفحة او الشركة التي تستخدمها للبيع',
        notes: 'ملاحظات',
        continue_shopping: 'اختر منتجات اخرى',
        place_order: 'ارسال الطلب',
        required: 'مطلوب',
        max_20_chars: 'الحد الاقصى 20 حرف',
        cart_empty: `العربة فارغة`,
        name_required: `الاسم مطلوب`,
        phone_required:  `رقم الهاتف مطلوب`,
        country_required: `البلد مطلوبة`,
        city_required: `المدينة مطلوبة`,
        address_required: `العنوان مطلوب`,
        business_name_required: `اسمك التجاري مطلوب مطلوب`,
        business_name_required_in_english: `يرجى ادخال الاسم التجاري باللغة الانجليزية`,
        welcome_to_ninja_sellers: 'اهلا بك في منصة نينجا سيليرز',
        confirm_email_instructions: 'يرجى منك تأكيد الايميل الخاص بك عبر اللينك الذي تم ارساله الى ايميلك',
        send_confirmation_email: 'ارسال ايميل التأكيد',
        contact_support_via_whatsapp: 'للتواصل مع الدعم، يمكنك التواصل معنا عبر واتساب',
        please_input_code: `يرجى ادخال الرقم السري`,
        wrong_code_try_again: `الرقم السري خطأ، يرجى المحاولة مجدداً`,
        phone_verification_success: `تم تأكيد رقمك بنجاح`,
        link_sent_to_email: `تم ارسال رابط الى الايميل الخاص بك`,
        call_center_fees: 'اجور خدمة الكول سنتر',
        shipping_fees_vendor: 'اجور التوصيل',
        cod_fees: 'اجور خدمة التحصيل',
        sales_tax_vendor: 'ضريبة القيمة المضافة',
        final_invoice_total: 'مجموع الفاتورة النهائي',
        contact_us_through_email: 'تواصل معنا من خلال البريد الإلكتروني',
        ninja_sellers_copyright: 'جميع الحقوق محفوظة لشركة نينجا سيلرز ',
        terms_and_conditions: 'الشروط والأحكام',
        follow_us_on_social_media: 'تابعنا على مواقع التواصل الإجتماعي',
        order_number: 'رقم الطلب',
        order_data: 'تاريخ الطلب',
        delivery_date: 'تاريخ التوصيل',
        order_status: 'حالة الطلب',
        customer_name: 'اسم العميل',
        phone_number: 'رقم الهاتف',
        tracking_number: 'رقم بوليصة الشحن',
        alternative_phone: 'رقم بديل',
        gross_total: 'المبلغ الاجمالي',
        net_profit: 'صافي الربح',
        dispatch_date: 'تاريخ الشحن',
        delivery_delayed_to: 'تم تأجيل استلام الطلب لتاريخ',
        order_status_details: 'تفاصيل حالة الطلب',
        cancel_details: 'تفاصيل سبب الرفض',
        order_details_lead: 'تفاصيل الطلب',
        edit_lead: 'تعديل الطلب',
        send_message_lead: 'ارسال رسالة',
        rate_order: 'تقييم الطلب',
        business_name: 'الاسم التجاري',
        the_product: 'المنتج',
        quantity: 'الكمية',
        unite_sold_price: 'السعر للقطعة',
        remove_order_from_import: 'ازالة الطلب من الاستيراد',
        order_details_import: 'تفاصيل الطلب',
        seller: 'المسوق',
        products: 'المنتجات',
        send_to_crm: 'ارسال الى الCRM',
        confirm_delete: 'تأكيد المسح',
        delete_order: 'مسح الطلب',
        order_details: 'تفاصيل الطلب',
        basic_information: 'المعلومات الاساسية',
        additional_fees: 'رسوم اضافية',
        order_status_followup: 'تتبع حالة الطلب',
        calls_followup: 'تتبع الاتصالات',
        close: 'اغلاق',
        order_id_order_rating: 'رقم الطلب | تقييم الطلب',
        order_number_send_message_about_order: 'رقم الطلب | ارسال رسالة بخصوص الطلب',
        message: 'الرسالة',
        basic_info: 'المعلومات الاساسية',
        follow_up_order_status: 'تتبع حالة الطلب',
        follow_up_calls: 'تتبع الاتصالات',
        price: 'السعر',
        profit: 'الربح',
        search: 'البحث',
        notifications: 'الاشعارات',
        my_products: 'منتجاتي',
        how_to_start_course: 'كورس كيف تبدأ',
        cart: 'سلة المشتريات',
        finish_placing_order: 'اكمال الشراء',
        my_account: 'حسابي',
        close_menu: 'اغلاق القائمة',
        ninja_sellers_services: 'خدمات نينجا سيلرز',
        ninja_sellers_academy: 'اكاديمية نينجا سيلرز',
        ninja_sellers_treasures: 'كنوز نينجا سيلرز',
        ignore: 'تجاهل',
        link: 'الرابط',
        add_new_settings: 'اضافة اعدادات جديدة',
        account: 'الحساب',
        settings: 'الإعدادات',
        percentage: 'النسبة (%)',
        add_settings: 'اضافة الإعدادات',
        update: 'تحديث',
        welcome_to_ninja_sellers: 'اهلا بك في منصة نينجا سيليرز',
        confirm_your_email: 'تأكيد الايميل الخاص بك',
        email_confirmed_successfully: 'تم تأكيد ايميلك بنجاح',
        next: 'التالي',
        please_confirm_your_email_by_clicking_link_sent_to_your_email: 'يرجى منك تأكيد الايميل الخاص بك عبر اللينك الذي تم ارساله الى ايميلك',
        send_confirmation_email: 'ارسال ايميل التأكيد',
        you_can_reach_support_on_whatsapp: 'للتواصل مع الدعم، يمكنك التواصل معنا عبر واتساب',
        ready_to_learn_ecom: 'هل انت جاهز لتعلم التجارة الالكترونية؟ ',
        all_what_you_need_to_learn: 'كل ما تحتاج تعلمه عن التجارة  والتسويق والاستفادة من منصة',
        ninja_sellers: 'نينجا سيلرز',
        we_provide_it_in_one_place: '، نقدمه في اكاديمية نينجا  في مكان واحد و',
        free: 'مجانا',
        start_now: 'ابدأ الان',
        secret_required: `يرجى ادخال الرقم السري`,
        wrong_secret_try_again: `الرقم السري خطأ، يرجى المحاولة مجدداً`,
        phone_confirmed: `تم تأكيد رقمك بنجاح`,
        link_sent_to_your_email: `تم ارسال رابط الى الايميل الخاص بك`,
        total_net_profit_order: 'مجموع صافي الربح',
        total_net_profit_usd_order: 'مجموع صافي الربح بالدولار',
        product_name: 'اسم المنتج',
        price: 'السعر',
        profit: 'الربح',
        quantity: 'العدد',
        total: 'المجموع',
        total_profit: 'مجموع الربح',
        total_profit_in_usd: 'الربح بالدولار',
        piece: 'قطعة',
        limited_offer: 'عرض مؤقت',
        net_profit: 'صافي الربح',
        offer_starts_in: 'سيبدأ العرض بعد',
        left_to_offer_end: 'بقي للعرض',
        day: 'يوم',
        hour: 'ساعة',
        minutes: 'دقيقة',
        second: 'ثانية',
        left: 'بقي',
        limited_quantity: 'الكمية محدوة',
        limited_offer_price_will_be_back_to: 'هذا العرض مؤقت وسيعود السعر الى',
        after: 'بعد',
        this_product_price_will_go_down_to: 'سينخفض سعر هذا المنتج الى',
        next_flash_sale: 'عرض الفلاش القادم',
        add_to_cart: 'اضافة الى السلة',
        list_of_invoices_by_country: 'قائمة الفواتير حسب البلد',
        total: 'المجموع',
        total_orders: 'مجموع الطلبات',
        subvendor_call_fees: 'اجور خدمة الكول سنتر',
        subvendor_shipping_fees: 'اجور التوصيل',
        subvendor_cod_fees: 'اجور خدمة التحصيل',
        subvendor_tax_fees: 'ضريبة القيمة المضافة',
        subvendor_total_fees: 'مجموع الفاتورة النهائي',
        call_or_call_trial: 'اتصال / محاولة اتصال',
        call_trial: 'محاولة اتصال',
        add_new_settings: 'اضافة اعدادات جديدة',
        settings_according_to_order_status: 'الإعدادات حسب حالة الطلب',
        call_center_fees_per_confirmed_order: 'اجور خدمة الكول سنتر لكل اوردر يتم تأكيده',
        call_center_fees_per_no_answer_cancel: 'اجور خدمة الكول سنتر لكل اوردر يتم الغاؤه بسبب عدم الرد من قبل الزبون',
        call_center_fees_per_order_canceled_by_customer: 'اجور خدمة الكول سنتر لكل اوردر يتم الغاؤه من قبل الزبون',
        call_center_fees_per_oreder_canceled_because_of_wrong_number: 'اجور خدمة الكول سنتر لكل اوردر يتم الغاؤه بسبب مشكلة في الرقم',
        call_center_fees_per_delivered_order: 'اجور خدمة الكول سنتر لكل اوردر يتم توصيله (تعبئة الخانة بقيمة خدمة الكول سنتر لكل اوردر يتم توصيله)',
        delivery_fees_for_undelivered_order: 'اجور خدمة التوصيل لكل اوردر لا يتم توصيله',
        delivery_fees_for_deliverd_order_in_addition_to_platform_fees: 'اجور خدمة التوصيل لكل اوردر يتم توصيله بالاضافة ل اجور التوصيل الموجودة على المنصة (يتم تعبئة هذه الخانة في حال تم الاتفاق مع الزبون بالفوترة على الاوردر الذي يتم توصيله فقط',
        vat_added_to_collected_amount_of_order: 'ضريبة القيمة المضافة على اجمالي تحصيل الاوردر',
        cod_collection_fees: 'اجور خدمة التحصيل',
        selected_if_agreement_on_return_fees_same_as_deliverd_fees: 'يتم اختيارها في حال تم الاتفاق مع الزبون بفوترة الاوردر الراجع نفس اجور التوصيل لكل مدينة',
        close: 'اغلاق',
        add_settings: 'اضافة الإعدادات',
        update: 'تحديث',
        please_verify_your_number: 'يرجى القيام بتأكيد رقم الهاتف الخاص بك',
        verify_your_phone_number: 'تأكيد رقم الهاتف',
        verify_phone_number: 'تأكيد رقم الهاتف',
        country_code: 'مفتاح الدولة',
        phone_number: 'رقم الهاتف',
        send_secret_code: 'ارسال الرقم السري',
        secret_code: 'الرقم السري',
        confirm_phone_number: 'تأكيد الرقم',
        cancel: 'الغاء',
        phone_number_reqired: '`رقم الهاتف مطلوب`',
        please_input_secret_code: 'يرجى ادخال الرقم السري',
        wrong_secret_code_try_again: `الرقم السري خطأ، يرجى المحاولة مجدداً`,
        phone_number_confirmed_successfully: `تم تأكيد رقمك بنجاح`,
        please_verify_your_email: 'يرجى القيام بتأكيد الايميل الخاص بك',
        send_verification_email: 'ارسال ايميل التأكيد',
        a_link_is_sent_to_your_email: `تم ارسال رابط الى الايميل الخاص بك`,
        identity_confirmation: 'إثبات الهوية الشخصية',
        information_to_confirm_your_identity: 'معلومات إثبات الهوية الشخصية للحساب الخاص بك',
        add_id_and_submit_for_verification: 'اضافة إثبات شخصيه وتقديمه للتحقق',
        confirm_account_identity: 'إثبات هوية الحساب',
        upload_id_image: 'تحميل صورة الهوية أو الاقامه',
        upload_id_or_passport_image: 'تحميل صورة جواز السفر / الهوية الشخصية',
        name_as_in_passport: 'الاسم كما هو موجود في الهوية الشخصيه أو جواز السفر',
        id_verification_is_being_proccessed: 'يتم دراسة طلب إضافة إثبات هوية',
        cancel: 'الغاء',
        add: 'اضافة',
        name_as_in_passport_short: 'الاسم في جواز السفر',
        confirmation_image: 'صورة الاثبات',
        review_is_done: 'تمت المراجعة',
        approved: 'تم الموافقة',
        rejected: 'تم الرفض',
        note: 'ملاحظة',
        ur_data_is_sent_for_verification: `تم ارسال بياناتك للتحقق `,
        service_pages: 'صفحات الخدمة',
        start_a_new_service_page: 'إنشاء صفحة جديدة',
        edit_page: 'تعديل الصفحة',
        page_title: 'عنوان الصفحة',
        menu_title: 'عنوان القائمة',
        contact_link: 'رابط التواصل',
        update: 'تحديث',
        click_here_to_contact_us: 'إضغط هنا للتواصل معنا',
        videos_and_articles_settings: 'ادارة المقالات والفيديوهات',
        academy_settings: 'ادارة الاكاديمية',
        add_article: 'اضافة مقال',
        add_section: 'اضافة قسم',
        add_keyword: 'اضافة كلمة مفتاحية',
        all_users: 'جميع المستخدمين',
        selected_users: 'اختيار حسابات محددة',
        all_active: 'حسابات فعالة',
        use_sku_recent: 'حسابات تبيع منتج اخر 48 ساعة',
        use_sku_month: 'حسابات تبيع منتج اخر شهر',
        sections_settings: 'ادارة الأقسام',
        keywords_settings: 'ادارة الكلمات المفتاحية',
        new_account: 'حساب جديد',
        affiliate_code: 'كود الاحالة',
        copy_affiliate_link: 'نسخ رابط الاحالة',
        personal_information: 'المعلومات الشخصية',
        you_can_edit_your_personal_info_and_some_settings: 'يمكنك تعديل معلوماتك الشخصية و بعض الإعدادات',
        name: 'الاسم',
        phone_number: 'رقم الهاتف',
        edit_information: 'تعديل المعلومات',
        change_password: 'تغيير كلمة المرور',
        you_can_change_your_password_here: 'يمكنك تغيير كلمة المرور من هنا',
        request_password_change_by_email: 'طلب تبديل كلمة السر عبر الايميل',
        refered_account: 'الحسابات المشار إليها',
        your_referals: 'الاحالات الخاصة بك',
        accounts_count: 'عدد الحسابات',
        orders_count: 'عدد الطلبات',
        business_account: 'الحساب التجاري',
        business_account_info_and_settings: 'معلومات واعدادات الحساب التجاري الخاص بك',
        allow_platform_to_change_pricing_on_confirm: 'السماح للمنصة بتبديل الاسعار عند تأكيد الطلب',
        notifications_by_email: 'التنبيهات عبر الايميل',
        edit_information: 'تعديل المعلومات',
        withdrawal_methods: 'طرق سحب الارباح',
        withdrawal_methods_info: 'معلومات واعدادات طرق سحب الارباح الخاصة بك',
        add_withdrawal_method: 'اضافة طريقة سحب جديدة',
        click_here_to_verify_your_account: 'يرجى الضغط هنا لتوثيق الحساب',
        withdrawal_method: 'طريقة لسحب الارباح',
        withdrwal_method_tool: 'طريقة استلام الارباح',
        payment_method_name: 'اسم خاص بك لطريقة الدفع',
        phone_number_for_account: 'رقم هاتف للحساب',
        account_identifier: 'معرف الحساب',
        paypal_email: 'ايميل حساب البايبال',
        bank_name: 'اسم البنك',
        bank_account_holder_name: 'اسم صاحب حساب البنك',
        account_number_iban: 'رقم حساب البنك IBAN',
        switft_code: 'كود الSWIFT',
        special_for_us_bank_accounts: 'خاص بحسابات الولايات المتحدة',
        account_number: 'رقم الحساب',
        currency: 'العملة',
        bank_address: 'عنوان البنك',
        detailed_address: 'عنوانك بالتفصيل',
        city: 'المدينة',
        name_as_in_passport: 'الاسم بحسب جواز السفر',
        request_is_evaluated_in_24_hours: 'يتم دراسة طلب اضافة طريقة الدفع خلال 24 ساعة عمل',
        add: 'اضافة',
        payment_method: 'طريقة الدفع',
        review_is_done: 'تمت المراجعة',
        approved: 'تم الموافقة',
        rejected: 'تم الرفض',
        note: 'ملاحظة',
        personal_information: 'المعلومات الشخصية',
        change_password: 'تغيير كلمة المرور',
        affiliates: 'الاحالات',
        business_account: 'الحساب التجاري',
        payment_methods: 'طرق الدفع',
        identity_verification: 'اثبات الهوية الشخصية',
        paypal_email_is_required: 'ايميل البايبال مطلوب',
        phone_number_is_required: `رقم الهاتف مطلوب`,
        all_bank_account_fields_required: `جميع بيانات حساب البنك مطلوبة`,
        payment_method_submitted_for_approval: `تم تقديم الطريقة للموافقة`,
        update_success: `تم التحديث`,
        please_verify_your_account_to_add_a_payment_method: "يرجى توثيق حسابك أولا لإضافة طريقة دفع",
        you_have_a_pending_verification_request: "لديك طلب توثيق قيد المراجعة",
        you_have_no_approved_identity_verification_request: "لا يوجد لديك طلب توثيق تم الموافقه عليه",
        all_accounts: 'جميع الحسابات',
        manage_platfrom_accounts: 'ادارة حسابات المنصة',
        search: 'بحث',
        active_accounts: 'الحسابات الفعالة',
        accounts_with_withdrawals: 'الحسابات التي استلمت ارباح',
        choose_country_to_show_products: 'اختر دولة لعرض منتجاتك فيها',
        soon: 'قريبا',
        products_count: 'عدد المنتجات',
        flash_offers: 'العروض المؤقته',
        show_all_offers: 'عرض جميع العروض',
        wait_for_best_offers: 'ترقبوا اقوى العروض',
        best_selling_products: 'المنتجات الاكثر مبيعا',
        show_all_best_sellers: 'عرض جميع المنتجات الاكثر مبيعا',
        latest_products: 'منتجات جديدة',
        show_all_latest_products: 'عرض جميع المنتجات الجديدة',
        all_products: 'جميع المنتجات',
        show_all_products: 'عرض جميع المنتجات',
        close: 'اغلاق',
        free: 'مجانا',
        all_id_verification_requests: 'جميع طلبات التحقق من الهويه',
        manage_id_verification_requests: 'ادارة طلبات التحقق من الهويه',
        pending_verification: 'بانتظار المراجعة',
        review_done: 'تمت المراجعة',
        approval_done: 'تمت الموافقة',
        notes: 'ملاحظات',
        update: 'تحديث',
        cancel: 'الغاء',
        import_orders: 'استيراد الطلبات',
        all_import_orders_details: 'كل معلومات طلباتك وتفاصيلها',
        new_account: 'حساب جديد',
        your_orders: 'الطلبات الخاصة بك',
        your_orders: 'كل معلومات طلباتك وتفاصيلها',
        search_by_phone_name_document_number: 'بحث بالاسم، رقم الهاتف، رقم الشحنة، او رقم الطلب',
        from_date: 'من تاريخ',
        to_date: 'الى تاريخ',
        orders: 'الطلبات',
        all_orders_details: 'كل معلومات الطلبات على المنصة',
        no_delivery_date: 'دون تاريخ توصيل',
        account_profit: 'ارباح حساب',
        account_name: 'اسم الحساب',
        account_id: 'رقم الحساب',
        total_account_profits: 'المجموع',
        total_ready_account_profits: 'جاهزة',
        total_pending_account_profits: 'معلقة',
        close: 'اغلاق',
        accounts: 'الحسابات',
        affiliated_with_account: 'يتبع لحساب',
        show_profits: 'عرض الارباح',
        email_notifications: 'التنبيهات عبر الايميل',
        payment_methods: 'طرق الدفع',
        record_transaction: 'تسجيل دفعة',
        payment_method: 'طريقة الدفع',
        review_done: 'تمت المراجعة',
        has_been_approved: 'تم الموافقة',
        has_been_rejected: 'تم الرفض',
        transaction_value: 'قيمة الدفعة',
        note: 'ملاحظة',
        export_accounts_list: 'تحميل قائمة بالحسابات',
        update_seminar_link: 'تحديث رابط السيمينار',
        seminar_link: 'رابط السيمينار',
        link: 'الرابط',
        all_settings: 'جميع الإعدادات',
        affiliate_settings_management: 'ادارة إعدادات الشركاء',
        add_new_settins: 'اضافة اعدادات جديدة',
        account: 'الحساب',
        country_id: 'رقم الدولة',
        percentage: 'النسبة',
        commission: 'العمولة',
        edit: 'تعديل',
        soon: 'قريباً',
        id_photo: 'صورة الهويه',
        name_as_in_passport: 'الاسم في جواز السفر',
        request_done: 'تم الطلب',
        last_update: 'اخر تحديث',
        account_id_verification: 'إثبات هوية الحساب',
        download_model_import_table: 'تحميل ملف موديل الطلبات',
        select_orders_import_file: 'فتح ملف الطلبات',
        confirm_orders_import: 'تأكيد استيراد جميع الطلبات',
        orders: 'الطلبات',
        number_of_orders_found: 'عدد الطلبات التي تم ايجادها',
        search: 'بحث',
        export_orders: 'تحميل الطلبات',
        affiliate_code: 'كود الاحالة',
        copy_affiliate_link: 'نسخ رابط الAffiliate',
        your_email_has_been_verified_you_can_start_working: 'تم تأكيد ايميلك بنجاح يمكنك الدخول لبدء العمل الآن',
        your_email_verification_didnt_work_please_contact_support: 'لم ينجح تأكيد ايميلك يرجى المحاولة مجددا او التواصل مع الدعم',
        login: 'تسجيل الدخول',
        information: 'المعلومات',
        register: 'التسجيل',
        first_name: 'الاسم الاول',
        last_name: 'اسم العائلة',
        residency_country: 'بلد الاقامة',
        your_phone_number_with_example: 'رقم هاتفك (966505707808)',
        phone_number_should_be_active_on_whatsapp: 'يجب ان يكون الرقم مفعل على واتساب لنتواصل معك',
        i_agree_to_terms_and_conditions: 'اوافق على الشروط والاحكام بعد الاطلاع عليها',
        terms_and_conditions: 'الشروط والاحكام',
        next: 'التالي',
        register_with_google: 'التسجيل باستخدام جوجل',
        or_register_using: 'او التسجيل باستخدام',
        confirm_password: 'تأكيد كلمة السر',
        login_with_google: 'الدخول باستخدام جوجل',
        or_login_via: 'او الدخول باستخدام',
        your_phone_number: 'رقم هاتفك',
        your_whatsapp_number: 'رقمك على الواتساب',
        your_facebook_account_link: 'رابط حسابك على الفيس بوك',
        sold_countries_history: 'الدول التي قمت بالبيع فيها سابقاً',
        ads_used_before: 'طرق التسويق والاعلان التي تقوم باستخدامها',
        total_monthly_ads_spend: 'كم المبلغ الذي تستثمره في الاعلانات شهرياً',
        average_weekly_orders: 'متوسط عدد الطلبات التي تقوم ببيعها اسبوعياً',
        residency_country_required: `بلد الاقامة مطلوبة`,
        first_name_required: `الاسم الاول مطلوب`,
        last_name_required: `اسم العائلة مطلوب`,
        phone_required:  `رقم الهاتف مطلوب`,
        enter_correct_phone_number: `يرجى ادخال رقم هاتف صحيح`,
        email_sent: `تم ارسال الايميل`,
        email_or_password_is_wrong: `كلمة السر او الايميل خطأ`,
        please_register_before_login: `يرجى التسجيل قبل محاولة الدخول`,
        account_created_logining_in: `تم انشاء الحساب بنجاح، جاري تسجيل الدخول.....`,
        please_confirm_password: `يرجى تأكيد كلمة السر`,
        confirm_password_not_matching: `كلمة السر غير مطابقة`,
        name_required: `الاسم مطلوب بهذه الطريقة`,
        email_required: `الايميل مطلوب للتسجيل بهذه الطريقة`,
        terms_acceptance_required: `يرجى الموافقة على الشروط والاحكام`,
        not_found: 'لا يوجد',
        none:'لا يوجد',
        facebook_ads:'اعلانات ممولة فيسبوك',
        google_ads:'اعلانات ممولة غوغل',
        tiktok_ads:'اعلانات ممولة تيك توك',
        instagram_ads:'اعلانات ممولة انستاغرام',
        snapchat_ads:'اعلانات ممولة سناب تشات',
        youtube_ads:'اعلانات ممولة يوتيوب',
        whatsapp_marketing:'تسويق عبر واتساب',
        facebook_groups_marketing:'تسويق عبر مجموعات فيسبوك',
        facebook_market_marketing:'تسويق عبر ماركيت بليس فيسبوك',
        sales_0:'صفر - لا زلت مبتدء في المجال',
        sales_50_to_100:'من 50-100 طلب اسبوعياً',
        sales_101_to_300: 'من 101-300 طلب اسبوعياً',
        sales_301_to_500: 'من 301-500 طلب اسبوعياً',
        sales_501_to_800: 'من 501-800 طلب اسبوعياً',
        sales_801_to_1000: 'من 801-1000 طلب اسبوعياً',
        sales_more_than_1000: 'اكثر من 1000 طلب اسبوعياً',
        ad_budget_none :'لا يوجد',
        ad_budget_0_to_500 :'0-500 دولار',
        ad_budget_501_to_1000 :'501-1000 دولار',
        ad_budget_1001_to_5000 :'1001-5000 دولار',
        ad_budget_5000_to_10000 :'5000-10000 دولار',
        ad_budget_more_than_10000 :'اكثر من 10000 دولار',
        you_are_qualified_and_added_to_newsletter_list: 'لقد ترشحت للسحب وتم دخولك للقائمة البريدية بنجاح',
        there_is_a_problem_please_contact_support: 'هنالك مشكلة يرجى التواصل مع الدعم',
        register: 'تسجيل الدخول',
        your_notifiations: 'الاشعارات الخاصة بك',
        your_account_and_orders_notification: 'الاشعارات الخاصة بطلباتك وحسابك',
        mark_all_notifications_as_read: 'قراءة كل الاشعارات',
        platform_notifications: 'الاشعارات الخاصة بالمنصة',
        home: 'الرئيسية',
        products: 'المنتجات',
        download_all_photos_to_your_pc: 'تحميل كافة الصور الى جهازك',
        product_name: 'اسم المنتج',
        product_code: 'كود المنتج',
        product_price: 'سعر المنتج',
        net_profit: 'صافي الربح',
        product_is_available: 'المنتج متوفر',
        number_of_pieces_availble: 'عدد القطع المتوفرة',
        offer_will_start_after: 'سيبدأ العرض بعد',
        day: 'يوم',
        hour: 'ساعة',
        minute: 'دقيقة',
        second: 'ثانية',
        the_price_of_this_product_will_drop_to: 'سينخفض سعر هذا المنتج الى',
        left_for_this_offer: 'متبقي لهذا العرض',
        this_offer_will_end_then_price_will_go_back_to: 'هذا العرض مؤقت وسيعود السعر الى',
        after: 'بعد',
        quantity: 'الكمية',
        reduce_quantity: 'تقليل الكمية',
        increase_quantity: 'زيادة الكمية',
        remove_from_cart: 'ازالة من السلة',
        add_to_your_products: 'اضافة الى منتجاتك',
        remove_from_your_products: 'ازالة من منتجاتك',
        finish_order: 'اكمال الطلب',
        product_is_available_in_the_following_countries: 'يتوفر المنتج في الدول التالية',
        quantity: 'الكمية',
        product_description: 'وصف المنتج',
        product_video: 'فيديو المنتج',
        similar_products: 'منتجات مشابهة',
        back_to_products: 'العودة الى المنتجات',
        added_to_your_products: `تم الاضافة الى منتجاتك`,
        removed_from_your_products: `تم الازالة من منتجاتك`,
        reports_about_your_orders: 'تقارير الطلبات الخاصة بك',
        from_date: 'من تاريخ',
        to_date: 'الى تاريخ',
        out_for_delivery_date_from: 'تاريخ خروج الطلب للتوصيل من',
        out_for_delivery_date_to: "تاريخ خروج الطلب للتوصيل الى",
        report_for_account: "تقرير لحساب",
        manjam_ninja_orders: "طلبات منجم نينجا",
        load_report: 'عرض التقرير',
        export_report: 'تحميل التقرير',
        total_orders: 'مجموع الطلبات',
        orders_in_last_30_days: 'طلب في اخر 30 يوم',
        profits: 'الارباح',
        order: 'طلب',
        invoices_total: 'مجموع الفواتير',
        confirmation_rate: 'معدل التأكيد',
        delivery_rate: 'معدل التوصيل',
        statistics_for_accounts_orders: 'احصائيات طلبات الحسابات',
        total: 'المجموع',
        show_more: 'عرض المزيد',
        orders_distribution_by_current_status: 'توزيع الطلبات بحسب الحالة الحالية',
        total_orders: 'مجموع الطلبات',
        average_profit_per_order: 'معدل الربح لكل طلب',
        expected_confirmation_rate: 'النسبة المتوقعه لتأكيد الطلبات',
        order_distribution_by_country: 'توزيع الطلبات بحسب الدولة',
        status_and_delivery_rates_per_country: 'نسب حالة الطلبات والتوصيل في كل دولة',
        the_10_best_seller_products_in_each_country: 'اكثر 10 منتجات مبيعا في كل دولة',
        best_seller_products_statuses_and_delivery_rate: 'نسب حالة الطلبات والتوصيل لاكثر المنتجات مبيعاً',
        pick_a_country_to_load_report: 'اختر دولة لعرض التقرير',
        calculate_expected_profit_by_product: 'حساب الارباح المتوقعه بحسب المنتج',
        pick_a_country_and_a_product_to_load_report: 'اختر دولة ومنتج لعرض التقرير',
        total_orders: 'مجموع الطلبات',
        net_profit: 'معدل الربح',
        expected_confirm_rate: 'معدل التأكيد المتوقع',
        expected_delivery_rate: 'معدل التوصيل المتوقع',
        total_expected_profit: 'مجموع الارباح المتوقعة',
        total_ad_spend_in_usd: "مجمل التكلفة للأعلانات بالدولار",
        orders_count: 'عدد الطلبات',
        no_data_to_export: 'لا يوجد معلومات للتحميل',
        pick_a_country: 'اختر دولة',
        soon: 'قريبا',
        search: 'البحث',
        no_results_please_try_again: 'لا يوجد نتائج للبحث، حاول مجدداً',
        submit_a_complaint: 'تقديم شكوى للمنصة',
        you_submit_all_your_complaint_details_to_get_help: 'يمكنك تقديم كافة تفاصيل الشكوى هنا حتى نتمكن من مساعدتك',
        subject_or_order_id: "الموضوع او رقم الطلب",
        complaint_details: "تفاصيل الشكوى",
        send: 'ارسال',
        submit_a_suggestion: 'تقديم مقترح للمنصة',
        submit_suggestion_details: 'يمكنك تقديم كافة تفاصيل المقترح هنا وكيف ستسخدمه في عملك',
        subject: 'الموضوع',
        suggestions_details: "تفاصيل المقترح",
        already_sent: `تم الارسال`,
        amounts_available_to_withdraw_except_what_is_withdrawn_already: 'المبالغ القابلة للسحب عدا المدفوع مسبقاً',
        usd: 'دولار',
        total_expected_profit: 'مجموع الارباح المتوقع',
        pending_profits_available_to_withdraw: 'المبالغ القابلة للسحب بعد مدة',
        total_profit_from_orders: 'مجموع الارباح من الطلبات',
        amounts_available_to_withdraw: 'المبالغ القابلة للسحب',
        orders: 'الطلبات',
        expected_profit_from_orders: 'ربح متوقع من الطلبات',
        orders_delivered_since_less_than_7_days: 'طلبات لم يمر على تسليمها 7 ايام',
        total_profits_from_affiliation: 'مجموع الارباح من الاحالة',
        amounts_available_to_withdraw: 'المبالغ القابلة للسحب',
        expected_profit_from_affiliation: 'ربح متوقع من الاحالة',
        withdrawal_requests: 'طلبات السحب',
        your_withdrawal_requests: 'طلبات السحب الخاصة بك',
        click_here_to_verify_your_account: 'يرجى الضغط هنا لتوثيق الحساب',
        click_here_to_add_payment_method: 'يرجى الضغط هنا لأضافة طريقة دفع',
        withdrawal_request: 'طلب السحب',
        fees_deducted_from_your_profits_as_per_payment_method: `يتم خصم مصاريف وعمولات التحويل من ارباحك بحسب طريقة استلام الارباح المحددة في حسابك`,
        withdraw_request: 'طلب سحب',
        profit_available_to_withdraw: 'المبلغ القابل للسحب',
        profit_withdrawal_method: "طريقة استلام الارباح",
        requested_withdrawal_amount_in_usd: "القيمة المطلوب سحبها بالدولار",
        withdrawal_request_is_proccessed_in_48_hours: 'يتم تنفيذ طلب السحب الدفع خلال 48 ساعة عمل',
        cancel: 'الغاء',
        add: 'اضافة',
        payment_method: 'طريقة الدفع',
        transaction_status: 'الحالة',
        transaction_date_time: 'التاريخ والوقت',
        under_review: 'قيد المراجعة',
        rejected: 'تم الرفض',
        was_approved: 'تم الموافقة',
        note: 'ملاحظة',
        transactions_and_paid_profits: 'الارباح المسحوبة والدفعات',
        what_was_already_paid_from_your_profits: 'ما تم دفعه بالفعل من ارباحك',
        amount: 'القيمة',
        status: 'الحالة',
        date: 'التاريخ',
        please_verify_your_account_to_request_withdrawal: "يرجى توثيق حسابك أولا لإتمام عملية السحب",
        you_have_a_pending_verification_request: "لديك طلب توثيق قيد المراجعة",
        you_have_no_approved_verification_request: "لا يوجد لديك طلب توثيق تم الموافقه عليه",
        you_have_no_approved_payment_method: "لا يوجد لديك طريقة دفع",
        all_payment_methods_are_under_review: "جميع طرق الدفع تحت المراجعه",
        you_dont_have_approved_payment_method: "لا يوجد لديك طريقة دفع حاصلة على موافقة",
        you_dont_have_enough_profits_to_withdraw: "لا يوجد رصيد كافي متوفر للسحب ",
        you_cant_submit_one_more_withdrawal_request: "لا يمكنك تقديم طلب سحب اضافي",
        no_bank_withdrawal_under_500_usd: "لا يمكن طلب السحب عبر حساب البنك لمبلغ اقل من 500 دولار",
        no_withdrawal_allowed_before_25_ready_profits: "غير مسموح طلب السحب قبل توفر مبلغ 25 دولار جاهزة للسحب على الاقل",
        please_refer_to_support_to_activate_withdrawals: "يرجى مراجعة الادارة لتفعيل طلب السحب",
        notes: 'ملاحظات',
        all_settings: 'جميع الإعدادات',
        manjam_settings_management: 'ادارة إعدادات منجم',
        add_new_settings: 'اضافة اعدادات جديدة',
        account: 'الحساب',
        number: 'رقم',
        country_id: 'رقم الدولة',
        percentage: 'النسبة',
        edit: 'تعديل',
        slider_settings: 'اعدادات السلايدر',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        total: 'المجموع',
        ///
        ///////////////// ABOVE THIS LINE ARE NEW TRANSLATIONS Home view
        hero_promo_country_count:
          "الان يمكنك البيع في 15 دولة عربية وإفريقية من مكانك من خلال العمل على منتجات المنصة أو استيراد منتجاتك الخاصة",
        hero_country_arabic: "السعودية",
        hero_country_kuwait: "الكويت",
        hero_country_oman: "عمان",
        hero_country_bahrain: "البحرين",
        hero_country_iraq: "العراق",
        hero_country_alardn: "الاردن",
        hero_country_lebya: "ليبيا",
        hero_country_felesteen: "فلسطين",
        hero_country_misr: "مصر",
        hero_country_emarat_arabia: "الامارات العربية المتحدة",
        hero_country_qatar: "قطر",
        hero_country_lebnan: "لبنان",
        hero_country_maghreb: "المغرب",
        hero_country_sanghal: "سنغال",
        hero_country_sahil: "ساحل العاج",
        hero_country_mr: "موريتانيا",
        // End of country name changes...
        partner_dream_ecommerce:
          "الشريك الذي يجعل حلمك في التجارة الالكترونية حقيقة",
        // ninja seller section translation
        ninja_seller_academy:
          "تعلم كل شيء عن التجارة الإلكترونية مع اكاديمية نينجا سيلرز",
        ninja_seller_offer: " ماذا ستقدم لك نينجا سيلرز  ",
        ninja_seller_offer_detail:
          "الآن أصبح الحلم حقيقة  معنا تستطيع بدء تجارتك الإلكترونية من أي مكان في العالم مع توفر جميع الخدمات من الشحن من الصين إلى مستودعاتنا المحلية من ثم تأكيد الطلب وتوصيله مع شركات توصيل محلية ومن ثم  التحصيل  من الزبون ، نوفر لك آلاف  المنتجات ويمكنك الاستفادة من جميع الخدمات و طلب استيراد بضاعتك الخاصة ونحن نتكفل بكل الخدمات",
        why_ninja_seller: " لماذا نينجا سيلرز ",
        why_ninja_seller_description:`
          لأننا نمتلك خبرة تجاوزت 8 سنوات بالتجارة الالكترونية مع الدفع عند الاستلام ويوجد لدينا بنية تحتية في جميع الدول  المتاحة على المنصة و نوفر ايضا أفضل الأسعار  مع أفضل خدمة  لجميع النينجا <br>


          لذلك وفرنا لك العمل ايضا بطريقتين<br> 
          1.العمل على بضاعتك الخاصة حيث يتم التكفل بكل ما تحتاجه لاستيراد بضاعتك الخاصة من تخليص وجمارك وغيرها<br>
          2.العمل على البضاعة المتوفرة على المنصة حيث تتوفر آلاف المنتجات مع امكانية تحديد سعر البيع دون اي قيود عليك<br>
        `,

        // project secion started
        project_starting_title: "ماذا احتاج حتى ابدأ تجارتي الالكترونية",
        project_starting_description:
          "عليك تطوير مهاراتك بالتسويق  و التركيز فقط على تسويق المنتجات",
        project_marketting_product: "ركز في التسويق لمنتجك",
        project_marketting_description:
          "سواء  كنت تعمل  على المنتجات المتاحة في  المنصة أو منتجاتك المستوردة الخاصة  بك نحن سنتكفل  بكل  احتياجاتك من تسجيل الطلب الى توصيله الى باب الزبون حتى تحويل  الارباح الى حسابك",
        project_wihtout_capital: "أقل نسبة مخاطرة",
        project_capital_decription:
          "إذا كنت تعمل على منتجات المنصة فلن تتكلف بأي تكاليف إلا في حال تم توصيل الطلب  وفي  حال  قررت استيراد بضاعتك الخاصة فأنت تدفع عند رفع الطلبات دون أي اشتراكات شهرية و تحصل على سعر واحد شامل  التخزين و التوصيل ايضا",
        project_net_profit: "صافي ربح كبير ",
        project_profit_decription:
          "يمكنك البيع  و  تحديد الربح المناسب لك ايضا  انت من تقوم بتحديد الربح المناسب  لك على جميع المنتجات و في جميع الدول",
        project_step_ecommerce: "يمكنك البيع على بضاعتك أو بضاعة المنصة",
        project_step_ecommerce_descr:
          "نوفر لك الاف المنتجات الرابحة  على المنصة في  جميع الدول  ونوفر خدمة استيراد بضاعتك الخاصة من البلد المنشأ إلى أي دولة من الدول المتاحة على المنصة مع تكفل  بجميع الخدمات",
        /// Services section
        service_section_title:"الخدمات التي  نقدمها  لمستوردي بضاعتهم الخاصة",
        service_section_sub_title:"",
        service_import_from_china:"استيراد بضاعتك من الصين",
        service_import_from_china_description:"",
        service_store_import_orders:"تخزين وتجهيز الطلبات",
        service_store_import_orders_decription:"",
        service_confirm_orders:"تأكيد و متابعة الطلبات",
        service_confirm_orders_decription:"",
        service_local_delivery:"توصيل مع شركات توصيل محلية",
        service_local_delivery_decription:"",
        service_cash_on_delivery:"خدمة التحصيل لدفع عند الإستلام",
        service_cash_on_delivery_description:"",
        // How ninja work become a ninja seller
        ninja_seller_start_now: "استغل  الفرصة الآن و انضم الى جيش النينجا سيلرز",
        ninja_how_web_work: "آلية عمل  المنصة",

        ninja_creat_account: "انشئ حسابك على موقع نينجا سيلرز مجانا",
        ninja_select_country_product:
          "اذا كنت مبتدأ ابدأ بتعلم مجانا من أكاديمية نينجا سيلرز كل شيء عن التجارة الالكترونية",
        ninja_fill_order:
          "حدد الدول والمنتجات التي تريد بيعها اما من المنتجات المتاحة على المنصة او قم باستيراد بضاعتك الخاصة",
        ninja_transfered_amount:
          "ابدأ برفع الطلبات على المنصة و نحن سنتكفل بكل شيء  حتى يتم تحصيل الأرباح و تحويلها  لك ",

        // what are you waiting for ninja section
        ninja_waiting_for_title: "ماذا تنتظر حتى تنضم لفريق نينجا سيلرز",
        ninja_waiting_for_description:
          "نينجا سيلرز تقوم بمساعدة أي شخص قرر أن يبدأ تجارته الإلكترونية مع الدفع عند الاستلام  وتمكينه من البيع في أكثر من دولة حيث انها توفر  آلاف المنتجات وتوفر لك ايضا خدمة استيراد بضاعتك الخاصة من أي دولة للدول المتاحة على المنصة حيث تتكفل بكل ما تحتاجه لاستيراد بضاعتك الخاصة  وتوفر له البنية التحتية الشاملة للبدء في مشروعه الخاص دون أي عقبات أو تكاليف بأقل نسبة مخاطرة",
        ninja_waiting_for_sub_description:'نينجا سيلرز فريق بخبرات ممتدة سيدعمك في كل ما تحتاجه حتى تبدأ العمل في مجال التجارة الالكترونية في أكثر من سوق وانت بمكانك بدون اي مصاريف تأسيس أو مصاريف ثابتة بتصّعب عليك الطريق،سوف نقدم لك المنتج المناسب وفي حال كنت تريد منتج خاص بك سوف نقوم باستيراد اي منتج تريده من اي دولة الى جميع مستودعاتنا الموجودة في الدول المتوفرة على المنصة  و القيام بجميع الخدمات اللوجستية وخدمات التخليص و الجمارك و الشحن و التخزين وتأكيد الطلبات و توصيل الطلبات مع شركات توصيل محلية وخدمات التحصيل و الدفع عند الاستلام للعميل و تحويل صافي الربح في وقت قياسي، يعني باختصار نينجا سيلرز بتعطيك البنية التحتية المتكاملة للبدأ بتجارتك الالكترونية مباشرة من مكانك بدون اي صعوبات، منصتّنا تتيح لك ادارة و متابعة الطلبات، مجموعة ضخمة متنوعة من المنتجات في أكثر من دولة، خدمة الشحن الداخلي السريع لزبائنك مع خاصية الدفع عند الاستلام و تحصيل أرباحك وانت بمكانك في وقت قياسي دون أي تعقيدات، لا تتردد في البدء فى كل ما تحتاجه أصبح متوفرا في مكان واحد مع فريق متخصص في مجال التجارة الالكترونية بخبرات ومؤهلات تتيح لك البيع في أكثر من دولة في نفس الوقت.',

        servicePages: "صفحات الخدمة",
        menu_label: "عنوان القائمة",
        desktop: "حاسوب",
        mobile: "الهاتف",
        order: "الترتيب",
        slides: "اعدادات السلايدر",
        order: "الترتيب",
        deleteBtn: "نعم, إحذف",
        areYouSureOfDelete: "هل أنت متأكد من حذف |item|",
        academyKeywords: "كلمات مفتاحية",
        academyCategories: "الأقسام",

        keywords: "كلمة مفتاحية",
        label: "العنوان",
        edit: "تعديل",
        title: "العنوان",
        image: "الصورة",
        category: "القسم",
        keyword: "كلمات دلالية",
        type: "النوع",
        body: "المحتوى",
        video_url: "رابط الفيديو",
        categories: "الأقسام",

        categories: "الأقسام",
        articles: "المقالات",
        academy: `الاكاديمية`,
        subVendorSettings: "اعدادات البائعين",
        manjamSettings: "اعدادات منجم",
        affilaiteSettings: "اعدادات الشركاء",
        subVendorProducts: "منتجاتك الخاصة",
        idVerifications: "التحقق",
        notificationsAdmin: "تنبيهات المنصة",
        notify: "ارسال الاشعارات",
        reports: "التقارير",
        /// //////////////// BAYAA
        transactions: "الدفعات",
        paymentMethods: "طرق الدفع",
        dashboard: "المنتجات",
        catalog: "منتجاتك المفضلة",
        shipping: "الشحن",
        tickets: "الدعم",
        wallet: "المحفظة",
        account: "حسابي",
        store: "متجرك",
        accounts: "الحسابات",
        requests: "طلبات السحب",
        leadsMaster: "كل الطلبات",
        user_exists_login: "الحساب مسجل لدينا، حاول الدخول ان كنت صاحب الحساب",

        /// ///
        item_name: "اسم المنتج",
        price: "السعر",
        quantity: "الكمية",
        order_total: "المجموع النهائي",
        your_details: "التفاصيل",
        item_total: "المجموع",
        continue_shopping: "مواصلة التسوق",
        submit_order: "إنهاء عملية الشراء",
        cart: "سلة المشتريات",
        order_now: "أطلبه الان",
        finish_order: "إنهاء الشراء",
        time_left: "الوقت المتبقي",
        details: "مواصفات المنتج",
        country_choose: "الرجاء اختيار دولتك",
        items_in_order: "المشتريات",
        name: "الاسم",
        phone_number: "رقم الهاتف",
        add_to_cart: "اضف الى السلة",
        thank_you: "تم ارسال طلبك بنجاح",
        tomorrow: "عد غدا مجددا لزيارتنا لاخر عروضنا",
        deliveryJO: "3 دنانير أجور توصيل",
        deliverySA: "اضف منتج اخر لتحصل على فينيير مجانا",
        deliveryJOS: "لقد حصلت على توصيل مجاني لطلبك",
        deliverySAS: "لقد حصلت على فينيير مجاني",
        delivery_total: "اجور التوصيل",
        delivery_free: "لقد حصلت على توصيل مجاني لطلبك",
        sold: "مباع ",
        piece: " قطعة",
        added_to_cart: "تم الاضافة الى السلة",
        size_color: "الحجم/اللون",
        cancel: "اغلاق",
        total: "المجموع",
        lowestJO: "اقل اسعار في الاردن",
        lowestSA: "اقل اسعار في السعودية",
        dismiss: "اغلاق",
        search: "بحث",
        back: "الرئيسية",
        tax: "شامل الضريبة",

        /// / nav
        start: "ابدأ الان",
        emailSoftware: "الايميلات",
        campaigns: "الحملات",
        campaign: "حملة",
        lists: "القوائم",
        list: "قائمة",
        templates: "القوالب",
        template: "قالب",
        accountCreated: "تم انشاء الحساب تواصل مع المدير للسماح لك بالدخول",
        sent: "ارسال",
        opened: "فتح",
        clicked: "نقر",
        lastChange: "اخر تحديث",
        agent: "الموظف",
        access: "الدخول",
        userRole: "نوع المستخدم",
        users: "مستخدمين",
        user: "المستخدم العادي",
        admin: "مدير",
        superadmin: "مدير عام",
        userEmail: "ايميل المستخدم",
        userName: "اسم المستخدم",
        close: "اغلاق",
        position: "المسمى الوظيفي",
        submitBtn: "تخزين",
        reload: "اعادة تحميل",
        subject: "العنوان",
        fromName: "اسم المرسل",
        fromEmail: "ايميل المرسل",
        replyTo: "الردود الى",
        lastUpdated: "اخر تحديث",
        sendingActive: "جاري الارسال...",
        inDraft: "مسودة",
        alreadySent: "تم ارسال",
        sendIconTooltip: "ارسال الان",
        scheduleIconTooltip: "الارسال لاحقاً",
        valid_email: "يرجى ادخال ايميل صحيح",
        leads: "الطلبات",
        subscribers: "ايميلات الملتحقين",
        suppression: "منع الارسال",
        offices: "المكاتب",
        loginWithGoogle: "الدخول باستخدام Google",
        register: "تسجيل",
        forgetPassword: "نسيت كلمة السر؟",
        sendResetEmail: "ارسال ايميل لاستعادة كلمة السر",
        please_use_google_to_login: "يرجى استخدام Google لتسجيل الدخول",
        user_not_found: "الحساب غير موجود",
        listings: "العروض",
        applicationsCenter: "مركز الطلبات",
        cv: "السيرة الذاتية",
        cvs: "السير الذاتية",
        resume: "السيرة الذاتية",
        resumes: "السير الذاتية",
        coverletters: "الرسائل",
        appsettings: "الاعدادات",
        applications: "الطلبات",
        inbox: "البريد",
        corporate: "المؤسسة",
        billing: "الفواتير",
        receipts: "المدفوعات",
        plan: "الخطة",
        upgradePlan: "ترقية",
        addToShortList: "اضافة الى المفضلة",
        shortlists: "المفضلة",
        note: "ملاحظة",
        from: "من",
        to: "الى",
        latest: "الاحدث",
        specialty: "الاختصاص",
        city: "المدينة",
        state: "الولاية",
        verified: "تم التحقق منه",
        prefer: "يفضل الايميل",
        limit: "الحد الاعلى",
        description: "وصف",
        "cover-letters": "الرسائل",

        /// //////////
        captcha: "الرجاء ادخال الرمز الموجود في الصورة",
        wrong_captcha: "لقد قمت بادخال رمز خطا",
        only_numbers: "يسمح بأدخال الارقام فقط",
        progressTitle: "التقدم",
        pdfReportsIconTooltip: "انشاء تقرير",
        generateReport: "انشاء تقرير",
        clearChart: "اعادة تعيين",
        cant_be_imported: "لا يمكن استيراد هذا الموظف",
        domain_not_allowed: "هذا النطاق غير مسموح به",
        allLegend: "مفتاح العتبات",
        specialAccess: "اعطاء المستخدم صلاحيات لعرض صفحات الوزارة",
        email: "الايميل",
        password: "كلمة السر",
        login: "تسجيل الدخول",
        send: "ارسال",
        home: "الرئيسية",
        max_retries: "تخطيت عدد المحاولات المسموحة",
        wrong_code: "خطأ في كتابة الرمز، يرجى المحاولة مرة اخرى",
        expired: "انهت صلاحية الجلسة",
        user_already_exists: "تم استيراد هذا المستخدم سابقاً",
        success: "تمت العملية بنجاح",
        not_found: "العنصر غير موجود",
        all_fields_required: "جميع الحقول مطلوبة",
        item_name_missing: "احد العناصر ينقصه اسم",
        organisation: "نظرة عامة على الوزارة",
        strategy: "استراتيجية الوزارة",
        orgProgress: "مقياس انجاز الوزارة",
        orgStructure: "الهيكل التنظيمي للوزارة",
        userSettings: "اعدادات المستخدم",
        mySpace: "المساحة الشخصية",
        notifications: "الاشعارات",
        progress: "الاهداف والمنجزات",
        report: "تقرير",
        managment: "لوحة التحكم",
        employees: "استيراد الموظفين",
        employeesSub: "ادارة الموظفين",
        charts: "الرسم البياني للأداء",
        approvals: "موافقاتي",
        user: "حسابي",
        orgStructureSetting: "تعديل الهيكل التنظيمي",
        settings: "الاعدادات",
        pubReports: "اصدار تقرير",
        logout: "الخروج",
        /// /// progress
        search: "ابحث",
        totalProgress: "اجمالي الانجازات",
        goals: "الاهداف",
        goal: "هدف",
        keyResult: "نتيجة رئيسية",
        keyResults: "نتائج رئيسية",
        initiative: "مبادرة",
        initiatives: "مبادرات",
        trend: "التباين",
        progress: "الاهداف والمنجزات الرئيسة",
        mainResult: "النتائج/المبادرات",
        status: "الحالة",
        change: "تعديل",
        editIconTooltip: "تعديل",
        deleteIconTooltip: "مسح",
        trending: {
          up: "تقدم",
          down: "تراجع",
          flat: "ثبات",
        },
        addGoal: "اضافة هدف",
        addGoalTitle: "اضافة هدف",
        editGoalTitle: "تعديل هدف",
        parentGoal: "هدف علوي يرتبط به",
        deleteGoalTitle: "مسح هدف",
        addKeyResult: "اضافة نتيجة",
        addKeyResultTitle: "اضافة نتيجة",
        editKeyResultTitle: "تعديل نتيجة",
        deleteKeyResultTitle: "مسح نتيجة",
        addInit: "اضافة مبادرة",
        addInitTitle: "اضافة مبادرة",
        editInitTitle: "تعديل مبادرة",
        deleteInitTitle: "مسح مبادرة",
        viewGoalTitle: "تفاصيل الهدف",
        viewKeyResultTitle: "تفاصيل النتيجة الرئيسية",
        viewInitTitle: "تفاصيل المبادرة",
        cancelBtn: "الغاء",
        addBtn: "اضافة",
        updateBtn: "تحديث",
        add: "اضافة",
        update: "تعديل",
        delete: "مسح",
        deleteMessage:
          "هل انت متأكد من ازالة هذا العنصر وكل ما يتعلق به بشكل نهائي؟",
        startValue: "قيمة البداية",
        targetValue: "قيمة الهدف",
        unite: "وحدة القياس",
        currentValue: "القيمة الحالية",
        weight: "قيمة المساهمة",
        quarter: "الربع",
        meters: "متر",
        dollar: "دولار امريكي",
        riyal: "ريال سعودي",
        rank: "ترتيب",
        number: "عدد",
        mbps: "Mbps",
        gbps: "Gbps",
        percentage: "%",
        quarter_one: "الربع الاول",
        quarter_two: "الربع الثاني",
        quarter_three: "الربع الثالث",
        quarter_four: "الربع الرابع",
        required: "مطلوب",
        upload: "تحميل ملف",
        confidential: "سري",
        normal: "عادي",
        fileType: "نوع الملف",
        files: "ملفات",
        date: "التاريخ",
        new: "جديد",
        theVision: "الرؤية",
        theMission: "المهمة",
        theMessage: "الرسالة",
        usersSettings: "اعدادات انواع المستخدمين",
        updateUser: "تحديث المستخدم",
        platformSettings: "اعدادات النظام",
        thresholdSettings: "اعدادات العتبات",
        uniteSettings: "اعدادات وحدات القياس",
        fileTypeSettings: "اعدادات تصنيف سرية المستندات الداعمة",
        allowedFilesSettings: "اعدادات انواع الملفات المسموحة",
        AddThreshold: "اضافة عتبة",
        name: "الاسم",
        percentageWord: "النسبة",
        saveSetting: "تخزين الاعدادات",
        slug: "اسم التخزين (دون فراغ)",
        arabic: "العربية",
        english: "الانجليزية",
        AddUnite: "اضافة وحدة",
        hundredError: "يجب ان يكون اقل من 100",
        AddFileType: "اضافة تصنيف",

        addMainLevel: "اضافة منصب اساسي",
        addBelow: "اضافة منصب فرعي",
        phoneNumber: "رقم الهاتف",
        importUser: "استيراد المستخدم وانشاء حساب",
        employeeData: "معلومات الموظف",
        employee: "الموظف",
        accept: "موافقة",
        type: "النوع",
        reject: "رفض",
        rejectMessage: "ملاحظة الرفض",
        acceptedNotification: "تم الموافقة على",
        rejectNotification: "تم رفض",
        submissionNotification: "بحاجة للمراجعة",
        deletionNotification: "تم مسح",
        pending: "بانتظار المراجعة",
        approved: "حصل على الموافقة",
        there: "هناك",
        createNewReport: "انشاء تقرير جديد",
        dones: "انجازات",
        todos: "خطط",
        supports: "بحاجة دعم",
        comments: "تعليقات",
        reportName: "اسم التقرير",
        fromDate: "من تاريخ",
        toDate: "الى تاريخ",
        newReportNotification: "تقرير جديد بعنوان",
        by: "بواسطة",
        submitReport: "تقديم التقرير",
        deleteReport: "مسح التقرير",
        updateReport: "تحديث التقرير",
        uniteThresholds: "توحيد الاعدادات لجميع الفئات من المنجزات",
        myReports: "تقاريري",
        employeesReports: "تقارير الموظفين",
        all: "الكل",
        totals: "اجمالي الانجازات",
        stepName: "اسم العتبة",
        stepSettings: "اعدادات العتبة",
        instituteSettings: "تعديل استراتيجية الوزارة",
        lastSeen: "اخر تحديث",
        getEmailNotifications:
          "الحصول على تنبيهات الأهداف و المنجزات و المبادرات عبر الايميل",
        getReportsByEmail: "الحصول على تنبيهات التقارير عبر الايميل",
        user_does_not_exist: "هذا المستخدم غير موجود",
        viewIconTooltip: "الاطلاع على التفاصيل",
        reportsIconTooltip: "الاطلاع على التقارير",
        closeBtn: "اغلاق",
        SMSCode: "الرمز المرسل في الرسالة النصية",
        academyLink: "اكاديمية نينجا سيلرز",
        academyIntroTooltip:
          "يمكنك الدخول من هنا و تعلم التجارة الالكترونية مجانا",
          seller_orders: "متابعة الطلبات ",
          screen_to_track:"شاشة لمتابعة الطلبات التي فشلت في التوصيل.",
          integrationSentId: "إعادة تعيين معرفات التكامل",
      },
    },
    modelMenu: [
      {
        icon: "inventory",
        text: "dashboard",
        path: "/dashboard",
        roles: ["master", "superadmin", "admin", "user", "user-agent", "dev"],
      },
      {
        icon: "inventory",
        text: "wholesaleProducts",
        path: "/wholesale-products",
        roles: ["master", "dev", "superadmin", "admin", "user", "user-agent"],
      },
      {
        icon: "shopping_basket",
        text: "purchaseOrders",
        path: "/purchase-orders",
        roles: ["master", "dev", "superadmin", "user", "user-agent", "business", "business-master"],
      },
      {
        icon: "analytics",
        text: "reports",
        path: "/reports",
        roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business", "business-master"],
      },

      {
        icon: "store",
        text: "store",
        path: "/store",
        roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
        subs: [
          {
            icon: "storefront",
            text: "subVendorProducts",
            path: "/sub-vendor",
            roles: ["master", "admin", "user", "user-agent", "dev", "business", "business-master"],
          },
          {
            icon: "analytics",
            text: "seller_orders",
            path: "/seller/orders",
            roles: ["master", "admin", "user", "user-agent", "dev", "business", "business-master"],
            description: "screen_to_track",

          },
          {
            icon: "apps",
            text: "catalog",
            path: "/catalog",
            roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
          },
          {
            icon: "shopping_cart",
            text: "leads",
            path: "/leads",
            roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
          },
          {
            icon: "local_shipping",
            text: "shipping",
            path: "/shipping",
            roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
          },
        ],
      },
      {
        icon: "apps",
        text: "forms",
        path: "/forms",
        roles: ["master", "dev", "user", "user-agent", "business", "business-master"],
        subs: [
          {
            icon: "apps",
            text: "form_list",
            path: "/FormBuilder/List/Form",
            roles: ["master", "dev", "user", "user-agent", "business", "business-master"],
          },
          {
            icon: "apps",
            text: "pixel",
            path: "/FormBuilder/List/Pixel",
            roles: ["master", "dev", "user", "user-agent", "business", "business-master"],
          },
          {
            icon: "apps",
            text: "planPrice",
            path: "/Subscription/Plan/Price",
            roles: ["master", "dev", "user", "user-agent", "business", "business-master"],
          },
          
        ],
      },
      
      {
        icon: "business",
        text: "account",
        path: "/account",
        roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
        subs: [
          {
            icon: "account_balance_wallet",
            text: "wallet",
            path: "/wallet",
            roles: ["master", "superadmin", "admin", "user", "dev", "business"],
          },
          {
            icon: "account_circle",
            text: "account",
            path: "/account",
            roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
          },
          {
            icon: "live_help",
            text: "tickets",
            path: "/tickets",
            roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
          },
          {
            icon: "shopping_cart",
            text: "leadsMaster",
            path: "/leads-master",
            roles: ["affiliate", "dev"],
          },
          {
            icon: "check_circle",
            text: "notifications",
            path: "/notifications",
            roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
          },
          {
            icon: "check_circle",
            text: "notificationsAdmin",
            path: "/admin-notifications",
            roles: ["master", "superadmin", "admin", "user", "user-agent", "dev", "business"],
          },
        ],
      },
      {
        icon: "extension",
        text: "integrations",
        path: "/integrations",
        roles: ["master", "dev"],
        subs: [
          {
            icon: "extension",
            text: "accountAppsSettings",
            path: "/app_account_settings",
            roles: ["master"],
          },
          {
            icon: "extension",
            text: "zidProducts",
            path: "/zid_products",
            roles: ["master"],
          },
          {
            icon: "extension",
            text: "ninjaProducts",
            path: "/ninja_products",
            roles: ["master"],
          },

        ],
      },
      {
        icon: "settings",
        text: "settings",
        path: "/settings",
        roles: ["master", "dev", "business-master"],
        subs: [
          {
            icon: "people",
            text: "users",
            path: "/users",
            roles: ["master", "dev", "business-master"],
          },
          {
            icon: "supervised_user_circle",
            text: "accounts",
            path: "/accounts",
            roles: ["master", "dev", "business-master"],
          },
          {
            icon: "integration_instructions",
            text: "integrationSentId",
            path: "/admin/integration-sent-id",
            roles: ["master", "dev"],
          },
          {
            icon: "check_box",
            text: "seller_orders",
            path: "/admin/seller/orders",
            roles: ["master", "dev"],
            // description: "إدارة الطلبات الشرائية الخاصة بك.",

          },
          {
            icon: "check_box",
            text: "planList",
            path: "/Subscription/Plan/List",
            roles: ["master", "dev"],
          },
          {
            icon: "price_change",
            text: "paymentMethods",
            path: "/payment-methods",
            roles: ["master", "dev"],
          },
          {
            icon: "face",
            text: "idVerifications",
            path: "/id-submissions",
            roles: ["master", "dev"],
          },
          {
            icon: "request_quote",
            text: "transactions",
            path: "/transactions-master",
            roles: ["master", "dev"],
          },
          {
            icon: "money",
            text: "requests",
            path: "/requests",
            roles: ["master", "dev"],
          },
          {
            icon: "play_circle",
            text: "academy",
            path: "/academy-admin",
            roles: ["master", "dev"],
          },
          {
            icon: "style",
            text: "academyKeywords",
            path: "/academy-keywords",
            roles: ["master", "dev"],
          },
          {
            icon: "play_circle",
            text: "academyCategories",
            path: "/academy-categories",
            roles: ["master", "dev"],
          },
          {
            icon: "slideshow",
            text: "slides",
            path: "/slides",
            roles: ["master", "dev"],
          },
          {
            icon: "shopping_cart",
            text: "leadsMaster",
            path: "/leads-master",
            roles: ["master", "dev", "business-master"],
          },
          {
            icon: "account_tree",
            text: "subVendorSettings",
            path: "/sub-vendor-settings",
            roles: ["master", "dev"],
          },
          {
            icon: "settings_suggest",
            text: "manjamSettings",
            path: "/manjam-settings",
            roles: ["master", "dev"],
          },
          {
            icon: "hub",
            text: "affilaiteSettings",
            path: "/affiliate-settings",
            roles: ["master", "dev"],
          },
          {
            icon: "description",
            text: "servicePages",
            path: "/service-pages",
            roles: ["master", "dev"],
          },
          {
            icon: "send",
            text: "notify",
            path: "/notify",
            roles: ["master", "dev"],
          },
          {
            icon: "checklist",
            text: "registerForms",
            path: "/registration-forms",
            roles: ["master", "dev"],
          },
          {
            icon: "payment",
            text: "purchaseOrderPaymentMethods",
            path: "/purchase-orders-payment-methods",
            roles: ["master", "dev", "superadmin"],
          },
        ],
      },
    ],
    menu: [],
    notify_board: [],
    access_token: null,
    verification: false,
    online: false,
    centralLogin: false,
    globalLoading: false,
    globalSnackBar: false,
    globalSnackBarSetting: {},
    user: null,
    users: [],
    uid: null,
    language: "ar",
    notifications: [],
    settings: {
      baseUrl: "",
      apiBase: "",
      public: "",
    },
    userRoles: [
      { slug: "master", text: "Master" },
      { slug: "business", text: "Business" },
      { slug: "business-master", text: "Business Master" },
      { slug: "superadmin", text: "Superadmin" },
      { slug: "admin", text: "Admin" },
      { slug: "user", text: "User" },
      { slug: "user-agent", text: "User Agent" },
      { slug: "dev", text: "Dev Team" },
    ],
    paymentMethods: [
      { slug: "cash", ar: "كاش", en:'Cash', active: false },
      { slug: "bank", ar: "عبر البنك", en:'Bank Transfer', active: true },
      {
        slug: "dinarak",
        ar: "محفظة دينارك",
        en:'Dinarak Wallet',
        active: true,
        number: true,
      },
      {
        slug: "orange",
        ar: "محفظة اورانج",
        en:'Orange Wallet',
        active: true,
        number: true,
      },
      {
        slug: "umaniah",
        ar: "محفظة امنية",
        en:'Umniah Wallet',
        active: true,
        number: true,
      },
      { slug: "paypal", ar: "بيبال | Paypal", en:"بيبال | Paypal", active: true },
      {
        slug: "zain_cash",
        ar: "زين كاش",
        en:'Zain Cash',
        active: true,
        number: true,
      },
      {
        slug: "vodafon_cash",
        ar: "فودافون كاش",
        en:'Vodafone Cash',
        active: true,
        number: true,
      },
      {
        slug: "snapchat",
        ar: "اضافة رصيد في الحساب الاعلاني سناب شات",
        en:'Snapchat Balance',
        active: true,
      },
      {
        slug: "tiktok",
        ar: "اضافة رصيد في الحساب الاعلاني تيك توك",
        en:'TikTok Balance',
        active: true,
      },
      {
        slug: "facebook",
        ar: "اضافة رصيد في الحساب الاعلاني فيسبوك",
        en:'Facebook Balance',
        active: true,
      },
      { slug: "payoneer", ar: "بايونير |  Payoneer", en:'Payoneer', active: true },
      {
        slug: "jawwalpay",
        ar: "جوال باي |  Jawwal Pay",
        en:'Jawwal Pay',
        active: true,
        number: true,
      },
      { slug: "stock_purchase", ar: "شراء بضاعة", en:'Goods', active: true },
      { slug: "cash_plus", ar: "Cash Plus", en:'Cash Plus', active: true },
      { slug: "usdt", ar: "USDT", en:'USDT', active: true },
    ],
    transaction_statuses: [
      { slug: "pending", ar: "قيد التنفيذ", en: "In Progress" },
      { slug: "transfered", ar: "تم التحويل", en: "Transferred" },
      { slug: "recieved", ar: "وصلت", en: "Received" },
      { slug: "rejected", ar: "تم الرفض", en: "Rejected" },
      { slug: "canceled", ar: "تم الالغاء", en: "Canceled" },
      { slug: "credit", ar: "اضافة للحساب", en: "Credit to Account" },
    ],
    products: [],
    raw_products: [],
    sort_products: [],
    meta_products: [],
    cart: [],
    customer: {},
    show_cart: false,
    cart_total: 0,
    total_profit: 0,
    base_total: 0,
    base_total_profit: 0,
    delivery_fees: 0,
    base_delivery_fees: 0,
    cart_delivery_fees: 0,
    base_cart_delivery_fees: 0,
    free_delivery_limit: 0,
    base_free_delivery_limit: 0,
    tax: 0,
    cart_tax: 0,
    comapny_code: "",
    comapny_code_settings: {},
    countries: [],
    countries_:{
      ar: {
        jo: "الاردن",
        ma: "المغرب",
        qa: "قطر",
        sa: "السعودية",
        kw: "الكويت",
        bh: "البحرين",
        ly: "ليبيا",
        iq: "العراق",
        eg: "مصر",
        ae: "الامارات",
        ps: "فلسطين",
        om: "عمان",
        lb: "لبنان",
        mr: "موريتانيا",
        sn: "السنغال",
        ci: "ساحل العاج",
        ma: "المغرب",
      },
      en: {
        jo: "Jordan",
        ma: "Morocco",
        qa: "Qatar",
        sa: "Saudi Arabia",
        kw: "Kuwait",
        bh: "Bahrain",
        ly: "Libya",
        iq: "Iraq",
        eg: "Egypt",
        ae: "United Arab Emirates",
        ps: "Palestine",
        om: "Oman",
        lb: "Lebanon",
        mr: "Mauritania",
        sn: "Senegal",
        ci: "Ivory Coast",
        ma: "Morocco",   // Note: You have Morocco (ma) twice in the list
      }
    },
    soon_countries: ["mr"],
    new_countries: [],
    country_dialog: false,
    location: {},
    country: {},
    manual_country: false,
    in_ashyaat_countries: false,
    country_code: "",
    test_country: null,
    facebook: null,
    instagram: null,
    whatsapp: null,
    currency_factor: "",
    currency_symbol: "",
    language: "ar",
    loading: false,
    globalLoading: false,
    next_page: null,
    admin_notifications: [],
    lazyLoad: false,
    landing_page: {},
    is_landing_page: false,
    is_search: false,
    thank_you: false,
    footer_pages: [],
    navigation_pages: [],
    pixel_submit: false,
    cats: [],
    cc: "JO",
    favs: [],
    miniCart: false,
    search: null,
    search_resource: null,
    category: null,
    edit_dialog: false,
    edit_lead: null,
    target_path: null,
    have_extra_service_fees: false,
    base_extra_service_fees: 0,
    extra_service_fees: 0,
    successMessage: '',
  },
  modules: {},
  getters: {
    getLocation(state) {
      return state.location;
    },
    getProducts(state) {
      return state.products;
    },
    cart(state) {
      return state.cart;
    },
  },
  mutations: {
    unAuthLogout(state) {
      state.access_token = null;
      state.user = null;
      state.uid = null;
      state.centralLogin = false;
      state.menu = [];
      state.globalLoading = [];
      state.users = [];
      state.notifications = [];
      state.admin_notifications = [];
      const noGate = [
        "home",
        "login",
        "register",
        "toc",
        "verify",
        "maillist",
        "consult",
        "trackorders",
      ];
      // console.log(router.currentRoute.name)
      if (!noGate.includes(router.currentRoute.name)) {
        router.push("/home").catch((x) => {});
      }
    },
    setOnline(state, payload) {
      state.online = payload == 1;
    },
    updateNotifications(state, payload) {
      // let newNotifications = payload.filter(x=>!state.notifications.map(x=>x.id).includes(x.id))
      state.notifications = payload; // [...newNotifications, ...state.notifications]
    },
    updateAdminNotifications(state, payload) {
      // let newNotifications = payload.filter(x=>!state.notifications.map(x=>x.id).includes(x.id))
      state.admin_notifications = payload; // [...newNotifications, ...state.notifications]
    },
    setBaseUrl(state, payload) {
      const localEnv = process.env.VUE_APP_VARS && process.env.VUE_APP_VARS === 'local'
      state.settings.baseUrl = `${payload.base}`;
      state.settings.apiBase = `${payload.base}${!localEnv?'':''}/api/v1`;
      state.settings.public = `${payload.base}${!localEnv?'':''}/storage/app/`;
    },
    buildStatuses(state, payload) {
      const a = state.statuses_info;
      for (let i = 0; i < a.length; i++) {
        const n = a[i];
        state.statuses_obj[n.status] = {};
        state.statuses_obj[n.status].ar = n.arabic;
        state.statuses_obj[n.status].en = n.english;
        state.statuses_obj[n.status].ar_info = n.info;
        state.statuses_obj[n.status].en_info = n.en_info;
      }
      const b = state.call_status_info;
      for (let i = 0; i < b.length; i++) {
        const n = b[i];
        state.call_statuses_obj[n.slug] = {};
        state.call_statuses_obj[n.slug].ar = n.ar;
        state.call_statuses_obj[n.slug].en = n.en;
      }
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setFavs(state, payload) {
      state.favs = payload;
    },
    setCountries(state, countries) {
      return new Promise(async (res, rej) => {
        state.countries = countries;
        res(true);
      });
    },
    setLocation(state, location) {
      return new Promise(async (res, rej) => {
        state.location = location;
        res(true);
      });
    },
    setCountry(state, country) {
      return new Promise(async (res, rej) => {
        state.tax = 0;
        state.cart_tax = 0;
        state.cart_total = 0;
        state.total_profit = 0;
        state.base_total = 0;
        state.base_total_profit = 0;
        state.delivery_fees = 0;
        state.base_delivery_fees = 0;
        state.cart_delivery_fees = 0;
        state.base_cart_delivery_fees = 0;
        state.free_delivery_limit = 0;
        state.base_free_delivery_limit = 0;
        state.tax = 0;
        state.cart_tax = 0;
        state.country_dialog = false;
        state.manual_country = localStorage.manual_country;
        const set_country = state.manual_country
          ? JSON.parse(localStorage.country)
          : country;

        state.country = set_country;
        state.cc = set_country.alpha2Code;
        state.comapny_code_settings = set_country.comapny_code_settings;
        state.comapny_code = set_country.comapny_code;
        state.in_ashyaat_countries = set_country.in_ashyaat_countries;
        state.country_dialog = !state.manual_country
          ? !set_country.in_ashyaat_countries
          : false;
        state.currency_factor = parseFloat(set_country.usd);
        state.base_delivery_fees = parseFloat(set_country.delivery_fees);
        state.delivery_fees = parseFloat(
          (
            parseFloat(set_country.delivery_fees) * state.currency_factor
          ).toFixed(8)
        );
        state.cart_delivery_fees = parseFloat(
          (
            parseFloat(set_country.delivery_fees) * state.currency_factor
          ).toFixed(8)
        );
        // console.log("state.cart_delivery_fees", state.cart_delivery_fees);
        state.tax = set_country.tax ? parseFloat(set_country.tax) / 100 : 0;
        // // console.log('tax', state.tax)
        state.base_free_delivery_limit = parseFloat(
          set_country.free_delivery_limit
        );
        state.free_delivery_limit = parseFloat(
          (
            parseFloat(set_country.free_delivery_limit) * state.currency_factor
          ).toFixed(8)
        );
        state.country_code = set_country.alpha2Code;
        // console.log(state.language)
        state.currency_symbol = state.language == 'ar' ? set_country.currencies[0].symbol : set_country.currencies[0].code;
        state.facebook = set_country.facebook;
        state.instagram = set_country.instagram;
        state.whatsapp = set_country.whatsapp;
        res(true);
      });
    },
    loadPage(state, page) {
      return new Promise(async (res, rej) => {
        state.is_landing_page = true;
        state.landing_page = page;
        res(true);
      });
    },
    loadSortedProducts(state, products) {
      return new Promise(async (res, rej) => {
        state.sort_products = products;
        res(true);
      });
    },
    loadMetaProducts(state, products) {
      return new Promise(async (res, rej) => {
        state.meta_products = products;
        res(true);
      });
    },
    loadProducts(state, products) {
      return new Promise(async (res, rej) => {
        const return_products = [];
        const favs = state.favs.map((x) => x.product_id);
        const filtered_products = state.sort_products.filter((x) =>
          x.countries.includes(state.country.id)
        );
        const final_products = filtered_products.length
          ? products.filter((x) =>
              filtered_products.map((y) => y.product_id).includes(x.id)
            )
          : products;
        state.raw_products = final_products;
        // console.log('final_products', final_products)
        for (let i = 0; i < final_products.length; i++) {
          if (favs.includes(final_products[i].id)) {
            final_products[i].fav = true;
          } else {
            final_products[i].fav = false;
          }
          final_products[i].active_image = final_products[i].image;

          const f = final_products[i].vprices.filter(
            (x) =>
              x.country &&
              (x.country.name == "ALL" || x.country.id == state.country.id)
          );
          // console.log('f.length', f.length, 'prices.web', final_products[i].prices.map(x=>x.web), 'prices.country.id', final_products[i].prices.map(x=>x.country.id))
          if (f.length) {
            // console.log('final_products[i]', final_products[i].sku)
            // console.log('final_products[i]', final_products[i].id)
            // console.log('final_products[i]', final_products[i].name_ar)
            final_products[i].currency_factor = state.currency_factor;
            final_products[i].base_price = parseFloat(
              parseFloat(f[0].value).toFixed(8)
            );
            final_products[i].price = parseFloat(
              (parseFloat(f[0].value) * state.currency_factor).toFixed(8)
            );
            if (f[0] && f[0].flash_item) {
              final_products[i].before_flash_price = parseFloat(
                (
                  parseFloat(f[0].before_flash_price) * state.currency_factor
                ).toFixed(8)
              );
              final_products[i].flash_item = true;
              final_products[i].flash_hours = f[0].flash_hours;
              final_products[i].flash_price = parseFloat(
                (parseFloat(f[0].flash_price) * state.currency_factor).toFixed(
                  8
                )
              );
              final_products[i].flash_start = f[0].flash_start;
              final_products[i].flash_end = f[0].flash_end;
              final_products[i].flash_start_hours = f[0].flash_start_hours;
              final_products[i].delayed_flash = f[0].delayed_flash;
              final_products[i].start_remaining = f[0].start_remaining;
              final_products[i].end_remaining = f[0].end_remaining;
              final_products[i].remaining_hours = f[0].remaining_hours;
            }
            final_products[i].base_profit = parseFloat(
              (parseFloat(f[0].value) * 0.2).toFixed(8)
            );
            final_products[i].profit = parseFloat(
              (parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(8)
            );
            final_products[i].user_base_profit = parseFloat(
              (parseFloat(f[0].value) * 0.2).toFixed(8)
            );
            final_products[i].user_profit = parseFloat(
              (parseFloat(f[0].value) * state.currency_factor * 0.2).toFixed(8)
            );
            // if(state.tax) {
            //   final_products[i].price = parseFloat((parseFloat(final_products[i].price) + final_products[i].price * state.tax).toFixed(1))
            // }
          } else {
            final_products[i].price = 0;
            if (!state.is_landing_page) {
              const f = final_products[i].vprices.filter(
                (x) => x.web && x.default
              );
              if (f.length) {
                final_products[i].price_name = f[0].name;
                final_products[i].base_price = parseFloat(
                  parseFloat(f[0].value).toFixed(8)
                );
                final_products[i].price = parseFloat(
                  (parseFloat(f[0].value) * state.currency_factor).toFixed(8)
                );
                // if(state.tax) {
                //   final_products[i].price = parseFloat((parseFloat(final_products[i].price) + final_products[i].price * state.tax).toFixed(1))
                // }
              } else {
                final_products[i].price = 0;
              }
            }
          }
          const c = final_products[i].remaining.filter(
            (x) => x.country_id == state.country.id
          );
          if (c.length) {
            final_products[i].count = c[0].count;
          }
          if(f[0].remaining_leads) {
            final_products[i].remaining_leads = f[0].remaining_leads
          }

          if (
            final_products[i] &&
            !state.products.map((x) => x.id).includes(final_products[i].id)
          ) {
            state.products.push(final_products[i]);
            return_products.push(final_products[i]);
          }
        }
        // console.log('state.products-', state.products)
        res(return_products);
      });
    },
    addProductToCart(state, product) {
      product.order_quantity = 1;
      product = recalculateProduct(product, state, product.flash_item);
      state.cart.push(product);
    },
    removeProductFromCart(state, product) {
      state.cart.splice(
        state.cart.findIndex((x) => x.sku == product.sku),
        1
      );
    },
    setProductTotals(state, product) {
      let current_product = state.cart.filter((x) => x.sku == product.sku)[0];
      current_product = recalculateProduct(
        current_product,
        state,
        product.flash_item
      );
      state.cart.splice(
        state.cart.findIndex((x) => x.sku == product.sku),
        1,
        current_product
      );
    },
    increaseQuantity(state, product) {
      let current_product = state.cart.filter((x) => x.sku == product.sku)[0];
      if (current_product.order_quantity < 10 * 1000) {
        current_product.order_quantity += 1;
        current_product = recalculateProduct(
          current_product,
          state,
          product.flash_item
        );
        state.cart.splice(
          state.cart.findIndex((x) => x.sku == product.sku),
          1,
          current_product
        );
      }
    },
    decreaseQuantity(state, product) {
      let current_product = state.cart.filter((x) => x.sku == product.sku)[0];
      if (current_product.order_quantity > 1) {
        current_product.order_quantity -= 1;
        current_product = recalculateProduct(
          current_product,
          state,
          product.flash_item
        );
        state.cart.splice(
          state.cart.findIndex((x) => x.sku == product.sku),
          1,
          current_product
        );
      }
    },
    showCart(state, status) {
      state.show_cart = status;
    },
    setCartTotal(state, payload) {
      return new Promise(async (res, rej) => {
        let total = 0;
        let base_total = 0;
        let total_profit = 0;
        let base_total_profit = 0;
        for (let i = 0; i < state.cart.length; i++) {
          const p = state.cart[i];
          total += p.total;
          total_profit += parseFloat(p.total_profit);
          base_total += parseFloat(p.base_total);
          base_total_profit += parseFloat(p.base_total_profit);
        }
        // if(total < state.free_delivery_limit && !state.free_delivery) {
        state.cart_delivery_fees = state.delivery_fees;
        state.base_cart_delivery_fees = state.base_delivery_fees;
        total += state.delivery_fees;
        base_total += state.base_delivery_fees;
        // } else {
        // state.cart_delivery_fees = 0
        // }
        if (state.tax) {
          const b = state.tax * total;
          total += b;
          base_total += state.tax * base_total;
          // total_profit += state.tax * total_profit
          // base_total_profit += state.tax * base_total_profit
          state.cart_tax = parseFloat(b.toFixed(8));
        }
        state.cart_total = parseFloat(total.toFixed(8));
        state.total_profit = parseFloat(total_profit.toFixed(8));
        state.base_total = parseFloat(base_total.toFixed(8));
        state.base_total_profit = parseFloat(base_total_profit.toFixed(8));
        localStorage.cart = JSON.stringify(state.cart);
        localStorage.cart_timestamp = new Date().getTime();

        if (
          state.country &&
          state.country.freeprofit &&
          state.base_total_profit > parseFloat(state.country.freeprofit)
        ) {
          const additional = parseFloat(state.country.taxafterfreeprofit);
          const taxable_base_profit =
            state.base_total_profit - parseFloat(state.country.freeprofit);
          const base_extra_service_fees = taxable_base_profit * additional;
          state.base_extra_service_fees = base_extra_service_fees;
          state.extra_service_fees =
            base_extra_service_fees * state.currency_factor;
          state.base_total += base_extra_service_fees;
          state.cart_total += base_extra_service_fees * state.currency_factor;
          state.have_extra_service_fees = true;
        } else {
          state.have_extra_service_fees = false;
        }
        res(true);
      });
    },
    loadCart(state) {
      return new Promise(async (res, rej) => {
        if (localStorage.cart) {
          const now = new Date().getTime();
          if (now - localStorage.cart_timestamp < 24 * 60 * 60 * 1000) {
            state.cart = JSON.parse(localStorage.cart);
          }
        }
        res(true);
      });
    },
    loadLanguage(state) {
      return new Promise(async (res, rej) => {
        if (localStorage.language) {
          state.language = localStorage.language;
          if (state.language == "ar") {
            Vue.prototype.$vuetify.rtl = true;
          } else {
            Vue.prototype.$vuetify.rtl = false;
          }
        } else {
          const language = "ar";
          state.language = language;
          localStorage.language = language;
          if (language == "ar") {
            Vue.prototype.$vuetify.rtl = true;
          } else {
            Vue.prototype.$vuetify.rtl = false;
          }
        }
        res(true);
      });
    },
    loadCustomer(state) {
      return new Promise(async (res, rej) => {
        if (localStorage.customer) {
          state.customer = JSON.parse(localStorage.customer);
        }
        res(true);
      });
    },
    setStaticPages(state, pages) {
      return new Promise(async (res, rej) => {
        state.pages = pages;
        state.footer_pages = pages.filter((x) => x.footer);
        state.navigation_pages = pages.filter((x) => x.navigation);
        res(true);
      });
    },
    setCategories(state, cats) {
      return new Promise(async (res, rej) => {
        state.cats = cats;
        res(true);
      });
    },
    openMiniCart(state, cats) {
      return new Promise(async (res, rej) => {
        const noMini = ["/checkout", "/leads"];
        if (!noMini.includes(router.currentRoute.path) && !state.edit_dialog) {
          state.miniCart = true;
          setTimeout((x) => {
            state.miniCart = false;
          }, 5000);
        }
        res(true);
      });
    },
    setSnackbar(state, payload) {
      state.globalSnackBar = payload.status
      state.globalSnackBarSetting = payload
    },
    closeSnackbar(state, payload) {
      state.globalSnackBar = payload.status
      state.globalSnackBarSetting = {}
    },
  },
  actions: {
    setSnackbar({ commit }, payload) {
      commit("setSnackbar", {status:true, ...payload});
      setTimeout(x=>{
        commit("setSnackbar", {status:false});
      }, 4000)
    },
    closeSnackbar({ commit }) {
      commit("setSnackbar", {status:false});
    },
    setSettingsBase({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        commit("setBaseUrl", payload);
        commit("buildStatuses");
        resolve(true);
      });
    },
    getUser({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .get(`${state.settings.apiBase}/user/me`)
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        await commit("setUser", a);
        await dispatch("getFavs");
        resolve(a);
      });
    },
    getFavs({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .get(`${state.settings.apiBase}/favs`)
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        await commit("setFavs", a.favs);
        resolve(a);
      });
    },

    checkAuth({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => {
            commit("unAuthLogout");
          }
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .get(`${state.settings.apiBase}/user/check`)
          .then((x) => x.data)
          .catch((error) => {
            // console.log(error)
          });
        resolve(a);
      });
    },
    logout({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            // assume your access token is stored in local storage
            // (it should really be somewhere more secure but I digress for simplicity)
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) =>
            // Do something with request error
            Promise.reject(error)
        );
        try {
          const a = await axios
            .get(`${state.settings.apiBase}/user/logout`)
            .then((x) => x.data);
          resolve(a);
        } catch (error) {
          resolve(false);
        }
      });
    },
    postResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .post(`${state.settings.apiBase}${payload.resource}`, {
            ...payload.value,
          })
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        resolve(a);
      });
    },
    getResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const filters = payload && payload.value && payload.value.filters ? payload.value.filters : {...payload.filters}
        const a = await axios
          .get(`${state.settings.apiBase}${payload.resource}${payload.page ? payload.page : ""}`, {params:{...filters}})
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        await dispatch("getAdminNotifications");
        resolve(a);
      });
    },
    getDirectResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const reqObject = {
          url:  `https://api.yervip.com/api/v1${payload.resource}${
            payload.page ? payload.page : ""
          }`,
          method: "GET",
        }
        if(payload.blob) {
          reqObject.responseType = "blob"
        }
        const a = await axios(reqObject)
          .then((x) => {
            console.log(x.headers["content-type"])
            return x.data
          })
          .catch((error) => {});
        // console.log(a)
        await dispatch("getAdminNotifications");
        resolve(a);
      });
    },
    getBackResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .get(
            `https://product.yervip.com/api/v1${payload.resource}${
              payload.page ? payload.page : ""
            }`
          )
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        if (a.countries) {
          await dispatch("getFavs");
          await commit("setCountries", a.countries);
          await dispatch("loadCompanyCodes", a.country);
          await commit("setLocation", a.location);
          await commit("setCategories", a.categories);
        }
        resolve(a);
      });
    },
    searchResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .post(
            `https://product.yervip.com/api/v1/ninjasearch/${
              state.country.alpha2Code
            }${payload.page ? payload.page : ""}`,
            { value: state.search }
          )
          .then((x) => x.data)
          .catch((error) => {});
        router.push("/search").catch((x) => {});
        state.products = [];
        const prod = await commit("loadProducts", a.data);
        state.search_resource = a;
        resolve(a);
      });
    },
    putResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .put(`${state.settings.apiBase}${payload.resource}`, {
            ...payload.value,
          })
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        resolve(a);
      });
    },
    deleteResource({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .delete(`${state.settings.apiBase}${payload.resource}`)
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        resolve(a);
      });
    },
    getNotifications({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .get(`${state.settings.apiBase}/notifications-mini`)
          .then((x) => x.data)
          .catch((error) => {});
        await commit("updateNotifications", a);

        resolve(a);
      });
    },
    getAdminNotifications({ commit, dispatch, state }) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .get(`${state.settings.apiBase}/admin-notifications-mini`)
          .then((x) => x.data)
          .catch((error) => {});
        await commit("updateAdminNotifications", a);

        resolve(a);
      });
    },
    postFileResource({ commit, state }, { resource, fileData }) {
      return new Promise(async (resolve, reject) => {
        // إعداد الـ Authorization Header
        const token = state.access_token;
        const apiBase = state.settings.apiBase;
    
        // إعداد الإعتراض على الطلب
        axios.interceptors.request.use(
          (config) => {
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
    
        // إعداد الإعتراض على الرد
        axios.interceptors.response.use(
          (response) => response,
          (error) => {
            if (error.response && error.response.status === 401) {
              commit("unAuthLogout");
            }
            return Promise.reject(error);
          }
        );
    
        try {
          const response = await axios.post(`${apiBase}${resource}`, fileData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
    
          resolve(response.data);
        } catch (error) {
          reject(error);
        }
      });
    },    
    firstLoad({ commit }) {
      commit("loadCart");
      commit("loadCustomer");
      commit("setCartTotal");
    },
    openCart({ commit }) {
      router.push("/checkout").catch((x) => {});
      // commit('showCart', true)
    },
    closeCart({ commit }) {
      router.push("/dashboard").catch((x) => {});
      // commit('showCart', false)
    },
    addToCart({ commit }, payload) {
      commit("addProductToCart", payload);
      commit("setCartTotal");
      commit("openMiniCart");
    },
    removeFromCart({ commit }, payload) {
      commit("removeProductFromCart", payload);
      commit("setCartTotal");
      commit("openMiniCart");
    },
    getProductTotals({ commit }, payload) {
      commit("setProductTotals", payload);
      commit("setCartTotal");
    },
    increaseQuantity({ commit }, payload) {
      commit("increaseQuantity", payload);
      commit("setCartTotal");
      commit("openMiniCart");
    },
    decreaseQuantity({ commit }, payload) {
      commit("decreaseQuantity", payload);
      commit("setCartTotal");
      commit("openMiniCart");
    },
    manualCountry({ commit, dispatch, state }, payload) {
      return new Promise(async (res, rej) => {
        // payload.delivery_fees = 10
        // payload.free_delivery_limit = 100

        state.products = [];
        state.manual_country = true;
        state.cart = [];

        localStorage.manual_country = true;
        localStorage.cart = JSON.stringify([]);
        localStorage.cart_timestamp = new Date().getTime();

        await dispatch("loadCompanyCodes", payload);
        // await dispatch('load_products', {page:`?page=${1}`})
        // await commit('loadProducts', state.raw_products)
        await commit("setCartTotal");
        res(true);
      });
    },
    async loadPages({ commit, dispatch, state }, id) {
      return new Promise(async (res, rej) => {
        const a = await axios
          .post(`${state.settings.apiBase}/static-all`, { country_id: id })
          .then((x) => x.data)
          .catch((error) => {});
        await commit("setStaticPages", a.pages);
        res(true);
      });
    },
    async loadCompanyCodes({ commit, dispatch, state }, in_country) {
      return new Promise(async (res, rej) => {
        let country = in_country;
        if (localStorage.country && localStorage.country != "undefined") {
          country = JSON.parse(localStorage.country);
        }
        // console.log(country)
        const settings_call = await axios
          .get("https://yervip.com/api/v1/ninjasettings")
          .then((x) => x.data);
        console.log(settings_call);

        const { settings_ } = settings_call.settings;
        const { ninja_conversion } = settings_call.settings;
        const { ninja_discount } = settings_call.settings;

        const search = country ? country.name : "";
        // console.log('search country', search)
        const settings = Object.values(settings_).filter((x) =>
          x.countries.includes(search)
        );
        if (country && settings.length) {
          // console.log('settings', settings)
          country.multi_discount = parseFloat(
            ninja_discount[country.alpha2Code]
          );
          country.usd = parseFloat(ninja_conversion[country.alpha2Code]);
          country.comapny_code_settings = settings[0];
          country.comapny_code = settings[0].company_code;
          // // console.log('country.comapny_code', country.comapny_code)
          country.delivery_fees = settings[0].delivery_fees;
          country.free_delivery_limit = settings[0].free_delivery_limit;
          country.in_ashyaat_countries = true;
          if (settings[0].tax) {
            country.tax = settings[0].tax;
          } else {
            country.tax = 0;
          }
        } else {
          // country.in_ashyaat_countries = false
        }
        if (localStorage.manual_country) {
          localStorage.country = JSON.stringify(country);
        }
        // await dispatch('loadPages', country.id)
        await commit("setCountry", country);
        res(true);
      });
    },
    async load_products({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              await dispatch("goOffline");
              commit("unAuthLogout");
            }
            return error;
          }
        );

        const a = await axios
          .get(
            `https://product.yervip.com/api/v1/bayaa/${
              state.cc ? state.cc : ""
            }${payload.page ? payload.page : ""}`
          )
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        /// /
        await dispatch("getFavs");
        await commit("setCountries", a.countries);
        await dispatch("loadCompanyCodes", a.country);
        await commit("setLocation", a.location);
        await commit("loadProducts", a.data);
        await commit("setCategories", a.categories);
        resolve(a);
      });
    },

    async load_fav_products({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              await dispatch("goOffline");
              commit("unAuthLogout");
            }
            return error;
          }
        );

        const a = await axios
          .post(
            `https://product.yervip.com/api/v1/bayaa-favs/${
              state.cc ? state.cc : ""
            }${payload.page ? payload.page : ""}`,
            { favs: state.favs },
            { headers }
          )
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        /// /
        await dispatch("getFavs");
        await commit("setCountries", a.countries);
        await dispatch("loadCompanyCodes", a.country);
        await commit("setLocation", a.location);
        await commit("loadProducts", a.data);
        await commit("setCategories", a.categories);
        resolve(a);
      });
    },
    async load_vendor_products({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              await dispatch("goOffline");
              commit("unAuthLogout");
            }
            return error;
          }
        );

        const a = await axios
          .get(
            `https://yervip.com/api/v1/sub-vendor/${
              state.cc ? state.cc : ""
            }${payload.page ? payload.page : ""}`,
            { favs: state.favs },
            { headers }
          )
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        /// /
        await dispatch("getFavs");
        await commit("setCountries", a.countries);
        await dispatch("loadCompanyCodes", a.country);
        await commit("setLocation", a.location);
        await commit("loadProducts", a.data);
        await commit("setCategories", a.categories);
        resolve(a);
      });
    },
    async search_products({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              await dispatch("goOffline");
              commit("unAuthLogout");
            }
            return error;
          }
        );
        // console.log(`${state.settings.apiBase}/websearch${payload.page?payload.page:''}`)

        const a = await axios
          .post(
            `${state.settings.apiBase}/websearch${
              payload.page ? payload.page : ""
            }`,
            { value: payload.value }
          )
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        state.products = [];
        state.sorted_products = [];
        state.is_search = true;
        await commit("setCountries", a.countries);
        await dispatch("loadCompanyCodes", a.country);
        await commit("setLocation", a.location);
        await commit("loadProducts", a.data);
        resolve(a);
      });
    },
    async load_page({ commit, dispatch, state }, payload) {
      return new Promise(async (resolve, reject) => {
        headers.Authorization = `Bearer ${state.access_token}`;
        axios.interceptors.request.use(
          (config) => {
            const token = state.access_token;
            if (token) {
              config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
          },
          (error) => Promise.reject(error)
        );
        axios.interceptors.response.use(
          async (response) => response,
          async (error) => {
            if (error.response.status === 401) {
              await dispatch("goOffline");
              commit("unAuthLogout");
            }
            return error;
          }
        );
        const a = await axios
          .post(`${state.settings.apiBase}${payload.resource}`, {
            ...payload.value,
          })
          .then((x) => x.data)
          .catch((error) => {});
        // console.log(a)
        /// /
        // a.country.delivery_fees = 10
        // a.country.free_delivery_limit = 100
        /// /
        await commit("setCountries", a.countries);
        await dispatch("loadCompanyCodes", a.country);
        await commit("setLocation", a.location);
        await commit("loadSortedProducts", a.products);
        await commit("loadMetaProducts", a.products_meta);
        await commit("loadProducts", a.products_raw);
        await commit("loadPage", a);
        resolve(a);
      });
    },
    async submitFormBuilder({ commit }, form) {
      try {
          const payload = {
              resource: '/storeDataForm',
              value: form,
          };
          const response = await this.dispatch('postResource', payload);
          
          console.log("Form submitted successfully", response);
          commit('setSuccessMessage', "Form submitted successfully!");
          return response;
      } catch (error) {
          console.error("Error submitting form", error);
          throw error;
      }
  },

    async submitPlan({ commit, state }, planData) {
      try {
          const payload = {
              resource: '/store/plans', // Assuming this is the resource endpoint
              value: planData,
          };
          const response = await this.dispatch('postResource', payload);
          
          console.log("Plan submitted successfully", response);
          commit('setSuccessMessage', "Plan submitted successfully!");
          return response;
      } catch (error) {
          console.error("Error submitting Plan", error);
          throw error;
      }
  },

  },
});
